<template>
  <div id="dashboard-analytics">
    <!-- ━━━━━━ 2FA reminder popup (fires once per dashboard mount if 2FA disabled) ━━━━━ -->
    <vs-popup
      title="Action required: secure your XYLO account"
      :active.sync="show2faPrompt"
      :button-close-hidden="false"
    >
      <div class="p-2">
        <vs-alert color="danger" icon-pack="feather" icon="icon-alert-triangle" :active="true" class="mb-4">
          <strong>Your XYLO account is at immediate risk.</strong><br/>
          The platform is under <strong>active attack</strong>. Stolen passwords are being used right now to break into accounts and exfiltrate confidential client data, prices, suppliers and orders. A single phishing email is enough to take over your account — and through it, the company's data.
        </vs-alert>
        <vs-alert color="warning" icon-pack="feather" icon="icon-clock" :active="true" class="mb-4">
          Two-factor authentication will be <strong>MANDATORY on May 31, 2026</strong>. After that date, no one will be able to log in without it. <strong>Don't wait until the last day</strong> — activate it now, it takes less than 2 minutes.
        </vs-alert>
        <p class="text-sm mb-2"><strong>Choose your second factor:</strong></p>
        <ul class="text-sm mb-4" style="list-style: disc; padding-left: 1.25rem;">
          <li><strong>Authenticator app (strongly recommended)</strong> — Google Authenticator, Microsoft Authenticator, Authy, 1Password. Works offline, no email delays, much harder to phish.</li>
          <li><strong>Email code</strong> — a 6-digit code sent to your inbox at every sign-in. Slower, and only as safe as your mailbox.</li>
        </ul>
        <div class="flex justify-end mt-4">
          <vs-button type="border" class="mr-2" @click="show2faPrompt = false">Remind me later</vs-button>
          <vs-button color="danger" icon-pack="feather" icon="icon-shield" @click="goTo2faSetup">Protect my account now</vs-button>
        </div>
      </div>
    </vs-popup>

    <div class="vx-row mt-4 ml-0 mr-4 mb-4" style="text-align: right">
      <!--Dashboard mode:&nbsp;&nbsp;
      <vs-switch color="dark" icon-pack="feather" vs-icon-on="icon-zap" vs-icon-off="icon-zap-off"
        v-model="toberefreshed">
        <span slot="on">ON</span>
        <span slot="off">OFF</span>
      </vs-switch>
      <font style="font-style: italic">(auto-refresh in {{ seconds }} seconds)</font>-->
    </div>
    <div class="vx-row">
      <div class="vx-col lg:w-7/12 w-full">
        <vx-card :title="getTitleLeft()">
          <!-- Price check (test phase): admins and moderators. Red with the count when probable errors exist. -->
          <template slot="actions">
            <vs-button v-if="canPriceCheck" size="small" :type="priceCheckQuotesErrors > 0 ? 'filled' : 'border'"
              :color="priceCheckQuotesErrors > 0 ? 'danger' : 'primary'" icon-pack="feather" icon="icon-check-circle"
              @click="priceCheckOpen = true">
              Price check<span v-if="priceCheckQuotesErrors > 0"> ({{ priceCheckQuotesErrors }})</span>
            </vs-button>
          </template>
          <div slot="no-body" class="mt-4 ml-4 mr-4 mb-4" v-if="quotation_dashboard.length > 0">
            <vs-table :data="quotation_dashboard" class="table-dark-inverted" search :max-items="1000">
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :class="{ 'row-pending-validation': tr.pending_admin_validation }">
                  <vs-td>
                    <vs-chip v-if="(
                      ((tr.volume - tr.volumetoprepare) / tr.volume) * 100
                    ) == 100
                    " class="ag-grid-cell-chips" :color="tr.pending_admin_validation ? '#bcbcbc' : 'success'"><span><small>{{ indextr + 1 }}.&nbsp;</small><b>
                          <router-link :to="{
                            path: '/quotation/' + tr.quotationref,
                          }" class="text-inherit" style="text-decoration: underline;">#{{ tr.quotationref
                          }}</router-link> ⟶
                        </b>
                        <span v-if="tr.date_delivery_desired == 'Invalid date'">No date</span>
                        <span v-else>
                          {{
                            displayDateddMMyyyy(tr.date_delivery_desired.substring(0, 10))
                          }}
                        </span>
                        ⟶
                        <big><b v-if="tr.volumetoprepare >= tr.volume">{{
                          Math.abs(tr.volume - tr.volumetoprepare).toFixed(2)
                            }}</b>
                          <b v-else>-{{
                            Math.abs(tr.volume - tr.volumetoprepare).toFixed(
                              2
                            )
                          }} </b>&nbsp;/&nbsp;<b>{{
                              Math.abs(tr.volume).toFixed(2)
                            }}</b>
                          <small>&nbsp;m3</small></big>&nbsp;<small v-if="tr.volumetoprepare >= tr.volume">({{
                            Math.abs(
                              ((tr.volume - tr.volumetoprepare) / tr.volume) *
                              100
                            ).toFixed(0)
                          }}% ready)</small>
                        <small v-else>({{
                          -Math.abs(
                            ((tr.volume - tr.volumetoprepare) / tr.volume) *
                            100
                          ).toFixed(0)
                        }}% ready)</small></span></vs-chip>
                    <vs-chip v-else class="ag-grid-cell-chips" :color="tr.pending_admin_validation ? '#bcbcbc' : 'danger'"><span><small>{{ indextr + 1
                    }}.&nbsp;</small><b>
                          <router-link :to="{
                            path: '/quotation/' + tr.quotationref,
                          }" class="text-inherit" style="text-decoration: underline;">#{{ tr.quotationref
                          }}</router-link> ⟶
                        </b>
                        <span v-if="tr.date_delivery_desired == 'Invalid date'">No date</span>
                        <span v-else>
                          {{
                            displayDateddMMyyyy(tr.date_delivery_desired.substring(0, 10))
                          }}
                        </span>
                        ⟶
                        <big>

                          <b v-if="tr.volumetoprepare >= tr.volume">
                            {{
                          Math.abs(tr.volume - tr.volumetoprepare).toFixed(2)
                            }}</b>
                          <b v-else>

                          -{{
                            Math.abs(tr.volume - tr.volumetoprepare).toFixed(
                              2
                            )
                          }} <!-- SI BUG ICI!!--> </b>&nbsp;/&nbsp;<b>{{
                            Math.abs(tr.volume).toFixed(2)
                          }}</b>
                          <small>&nbsp;m3</small></big>&nbsp;<small v-if="tr.volumetoprepare >= tr.volume">({{
                            Math.abs(
                              ((tr.volume - tr.volumetoprepare) / tr.volume) *
                              100
                            ).toFixed(0)
                          }}% ready)</small>
                        <small v-else>({{
                          -Math.abs(
                            ((tr.volume - tr.volumetoprepare) / tr.volume) *
                            100
                          ).toFixed(0)
                        }}% ready)</small></span></vs-chip>
                    &nbsp;
                    <vs-chip class="ag-grid-cell-chips" color="">
                      <img height="20px" v-if="tr.country_code == 'BE'" src="@/assets/images/flags/BE.png" alt="BE" />
                      <img height="20px" v-else-if="tr.country_code == 'HU'" src="@/assets/images/flags/HU.png"
                        alt="HU" />
                      <img height="20px" v-else-if="tr.country_code == 'AT'" src="@/assets/images/flags/AT.png"
                        alt="AT" />
                      <img height="20px" v-else-if="tr.country_code == 'NL'" src="@/assets/images/flags/NL.png"
                        alt="NL" />
                      <img height="20px" v-else-if="tr.country_code == 'CH'" src="@/assets/images/flags/CH.png"
                        alt="CH" />
                      <img height="20px" v-else-if="tr.country_code == 'DE'" src="@/assets/images/flags/DE.png"
                        alt="DE" />
                      <img height="20px" v-else-if="tr.country_code == 'ES'" src="@/assets/images/flags/ES.png"
                        alt="ES" />
                      <img height="20px" v-else-if="tr.country_code == 'FR'" src="@/assets/images/flags/FR.png"
                        alt="FR" />
                      <img height="20px" v-else-if="tr.country_code == 'IT'" src="@/assets/images/flags/IT.png"
                        alt="IT" />
                      <img height="20px" v-else-if="tr.country_code == 'LU'" src="@/assets/images/flags/LU.png"
                        alt="LU" />
                      <img height="20px" v-else-if="tr.country_code == 'RO'" src="@/assets/images/flags/RO.png"
                        alt="RO" />
                      <img height="20px" v-else-if="tr.country_code == 'GB'" src="@/assets/images/flags/UK.png"
                        alt="GB" />
                      <img height="20px" v-else-if="tr.country_code == 'PT'" src="@/assets/images/flags/PT.png"
                        alt="PT" />
                      <img height="20px" width="20px" v-else-if="tr.country_code == 'JP'"
                        src="@/assets/images/flags/JP.png" style="
  border-radius: 100%;" alt="JP" />
                      <img height="20px" width="20px" v-else-if="tr.country_code == 'CA'"
                        src="@/assets/images/flags/CA.png" style="
  border-radius: 100%;" alt="CA" />
                      <img height="20px" v-else src="@/assets/images/flags/UE.png" alt="EU" />&nbsp;&nbsp;
                      <router-link :to="{
                        path: '/person/' + tr.client_id,
                      }" class="text-inherit" style="text-decoration: underline;">
                        {{ tr.client }}</router-link> &nbsp;

                      <font v-if="tr.place">({{ tr.place }} {{ tr.postal_code }})</font>
                      <font v-else>(No delivery address)</font>
                    </vs-chip>
                    <vs-chip v-if="tr.transport && tr.transport.people.length > 0" class="ag-grid-cell-chips"
                      color="#A9CAB7">
                      <router-link v-if="tr.idtransport" :to="{
                        path: '/transport/' + tr.idtransport,
                      }" class="text-inherit" style="text-decoration: underline;">
                        <span>#{{ tr.transport.id }} | {{ displayDateddMMyyyy(tr.transport.date) }}</span></router-link>

                      &nbsp;
                      <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                    </vs-chip>
                    <vs-chip v-else-if="tr.transport && tr.transport.people.length == 0
                    " class="ag-grid-cell-chips" color="#c2d1f0">
                      <router-link v-if="tr.idtransport" :to="{
                        path: '/transport/' + tr.idtransport,
                      }" class="text-inherit" style="text-decoration: underline;">
                        <span>#{{ tr.transport.id }} | {{ displayDateddMMyyyy(tr.transport.date) }}</span></router-link>&nbsp;
                      <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                    </vs-chip>
                    <vs-chip v-if="tr.mail_top" class="ag-grid-cell-chips" color="#ffc266">
                      <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5" @click="openThePopup(tr)" /></vs-chip>
                    <vs-chip v-if="tr.alertneeded" class="ag-grid-cell-chips" color="red">
                      <feather-icon v-if="tr.alertneeded" icon="AlertTriangleIcon"
                        svgClasses="w-5 h-5 hover:text-danger stroke-current"
                        @click.stop="popupDescription = true; createdDate = 'Creation: ' + tr.created; updatedDate = 'Edition: ' + tr.updated" />
                    </vs-chip>
                    <vs-chip v-if="tr.idbroker" color="pink">
                      <feather-icon icon="GitMergeIcon" svgClasses="h-5 w-5" @click="openThePopup(tr)" />
                    </vs-chip>
                    <br />
                  </vs-td>
                  <vs-td style="width: 10px">
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5" @click="openThePopup(tr)" />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
          <div v-else slot="no-body" class="mt-4 ml-4 mr-4 mb-4">
            <p>{{ loadingText }}</p>
            <div class="fill-row-loading">
              <div id="loading-radius" class="loading-example">
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card title="Destination" v-if="quotation_dashboard.length > 0">
          <template>
            <div>
              <div v-if="!showMap" class="flex flex-col items-center justify-center" style="height: 200px">
                <p class="mb-4 text-center">Click to display the map</p>
                <vs-button icon-pack="feather" icon="icon-map" @click="showMap = true">Display map</vs-button>
              </div>
              <GmapMap v-else id="map" :center="center" :zoom="4" map-type-id="terrain" style="width: 100%; height: 500px">
                <GmapInfoWindow v-for="(m, index) in markers" :key="index" :position="m" :closable="false">
                  <!-- Chip pour l'état de préparation -->
                  <vs-chip :color="isFullyPrepared(index) ? 'success' : 'danger'" class="ag-grid-cell-chips">
                    <span>
                      <small>{{ index + 1 }}.</small>
                      <b> #{{ m.quotationref }} ⟶ </b>
                      <span v-if="isFullyPrepared(index)">
                        ready&nbsp;({{ Math.abs(m.volume.toFixed(0)) }} m³)
                      </span>
                      <span v-else>
                        <big>{{ Math.abs(getPreparationPercentage(index).toFixed(0)) }}%</big> ready
                      </span>&nbsp;({{ Math.abs(m.volume.toFixed(0)) }} m³)
                    </span>
                  </vs-chip>

                  <br />

                  <!-- Chip pour le transport -->
                  <vs-chip :color="m.transport && m.transport.people.length > 0 ? '#A9CAB7' : '#c2d1f0'"
                    class="ag-grid-cell-chips" v-if="m.transport">
                    <span>{{ m.transport.id }}</span>&nbsp;
                    <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                  </vs-chip>
                </GmapInfoWindow>
              </GmapMap>
            </div>
          </template>
        </vx-card>
      </div>

      <div class="vx-col lg:w-5/12 w-full">
        <vx-card title="eInvoice" class="mb-0" v-if="isAdmin">
          <div slot="no-body" class="p-5 mt-0 ml-4 mr-4 mb-4">

            <!-- CHARGEMENT EN COURS -->
            <div v-if="isLoadingEFactura">
              <p class="text-center font-bold">Connecting with SPV...</p>
              <div class="fill-row-loading">
                <div id="loading-radius2" class="loading-example"></div>
              </div>
            </div>

            <!-- CONTENU SI CHARGEMENT TERMINÉ -->
            <div v-else>
              <div class="vx-row justify-center">
                <!-- À ENVOYER -->
                <vs-chip v-if="getefacturatobesent > 0" color="danger">
                  <feather-icon icon="UploadCloudIcon" svgClasses="h-4 w-4" class="mr-1" />
                  <router-link :to="{ path: '/efacturalist-out' }" class="text-inherit">
                    To be sent: {{ getefacturatobesent }}
                  </router-link>
                </vs-chip>
                <vs-chip v-else color="success">
                  <feather-icon icon="UploadCloudIcon" svgClasses="h-4 w-4" class="mr-1" />
                  eFactura for clients has been processed
                </vs-chip>

                <!-- REÇU MAIS NON TRAITÉ -->
                <vs-chip v-if="getefacturareceived > 0" color="danger">
                  <feather-icon icon="DownloadCloudIcon" svgClasses="h-4 w-4" class="mr-1" />
                  <router-link :to="{ path: '/efacturalist-in' }" class="text-inherit">
                    Received but not processed: {{ getefacturareceived }}
                  </router-link>
                </vs-chip>
                <vs-chip v-else color="success">
                  <feather-icon icon="DownloadCloudIcon" svgClasses="h-4 w-4" class="mr-1" />
                  eFactura from providers has been processed
                </vs-chip>
              </div>
            </div>

          </div>
        </vx-card>

        <!-- Price check (test phase) — admins and moderators, opened from the button of the « Orders in progress »
             card. The orders of that list compared with the XYLO-PRICING catalogue (edition active
             when each line was priced): one row per order with its commercial level and its worst
             line. Computed by /api/pricecheck/summary on load (cached 10 min server side). -->
        <vs-popup class="price-check-popup" title="Price check" :active.sync="priceCheckOpen">
          <p class="mb-4" style="color: #888;">Orders in progress vs catalogue 2026 · test phase</p>

          <!-- Still computing (a few seconds) -->
          <p v-if="!priceCheck && !priceCheckError" class="text-center" style="color: #b8b8b8;">
            Checking…
          </p>

          <!-- The check could not run: say it -->
          <div v-else-if="priceCheckError" class="vx-row justify-center">
            <vs-chip color="danger">
              <feather-icon icon="XCircleIcon" svgClasses="h-4 w-4" class="mr-1" />
              Price check unavailable: {{ priceCheckError }}
            </vs-chip>
          </div>

          <div v-else>
            <!-- Counters -->
            <div class="vx-row justify-center">
              <vs-chip v-if="priceCheckQuotesErrors > 0" color="danger">
                <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" class="mr-1" />
                {{ priceCheckQuotesErrors }} probable price error{{ priceCheckQuotesErrors === 1 ? '' : 's' }}
              </vs-chip>
              <vs-chip v-else-if="priceCheckQuotesOff > 0" color="success">
                <feather-icon icon="CheckIcon" svgClasses="h-4 w-4" class="mr-1" />
                No probable error
              </vs-chip>
              <vs-chip v-else color="success">
                <feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4" class="mr-1" />
                All orders at catalogue price
              </vs-chip>
              <vs-chip v-if="priceCheckQuotesOff > 0" color="warning">
                <feather-icon icon="TrendingUpIcon" svgClasses="h-4 w-4" class="mr-1" />
                {{ priceCheckQuotesOff }} order{{ priceCheckQuotesOff === 1 ? '' : 's' }} off catalogue level
              </vs-chip>
            </div>

            <!-- Why prices can legitimately differ: notice that unfolds the explanation (no nested popup) -->
            <div class="mt-3 text-center">
              <small class="cursor-pointer" style="color: #FF9F43;" @click="priceCheckHelp = !priceCheckHelp">
                <feather-icon icon="AlertCircleIcon" svgClasses="h-4 w-4" class="mr-1" />
                Why a price can differ from the catalogue
                <feather-icon :icon="priceCheckHelp ? 'ChevronUpIcon' : 'ChevronDownIcon'" svgClasses="h-4 w-4" class="ml-1" />
              </small>
            </div>
            <div v-if="priceCheckHelp" class="mt-3 p-4" style="border: 1px solid #eee; border-radius: 6px; background: #fafafa; line-height: 1.6;">
              <p>Qzero prices each line from the catalogue, in the client's zone. On creation the server <b>realigns any line more than 1 % off</b>.</p>
              <p class="mt-2"><b>Kept as is, by rule:</b></p>
              <ol class="pl-6" style="list-style: decimal;">
                <li>a line with an explicit reason (finish, negotiated price);</li>
                <li>a product already invoiced to this client, at its usual price;</li>
                <li>no catalogue price, or a cell out of range: the client's last invoice counts.</li>
              </ol>
              <p class="mt-2">The agent sees the client's last invoiced prices and must flag gaps. A person approves the quote.</p>
              <p class="mt-3"><b>Here</b></p>
              <ul class="pl-6" style="list-style: disc;">
                <li><span class="text-danger"><b>Probable error</b></span>: a comparable line 15 points or more away from its own quote's level, never invoiced at that price to this client.</li>
                <li><span class="text-warning"><b>Difference</b></span>: follows the quote's level (negotiated price, previous tariff, other zone) or the client's last invoice.</li>
                <li><b>Not comparable</b>: custom description, approximate cell, other dimensions, no catalogue price. Counted, never flagged.</li>
                <li><b>Why it can still make sense</b>: <span class="text-success"><b>✓</b></span> every line off the catalogue has an explanation, <span class="text-danger"><b>✗</b></span> at least one has none. The text explains the worst line; possible explanations, in order: the client's own invoices at that price, the previous tariff (catalogue ÷ 1.05), another zone's price, a sanded finish, the same price invoiced to other clients, the quote's overall level. The client's oil +5 % surcharge is flagged when this quote does not carry it.</li>
              </ul>
            </div>

            <!-- Orders: errors first, then off-level orders -->
            <vs-table v-if="priceCheckRows.length" :data="priceCheckRows" class="mt-4" :max-items="10" pagination>
              <template slot="thead">
                <vs-th>Order</vs-th>
                <vs-th>Client</vs-th>
                <vs-th>Broker</vs-th>
                <vs-th>Date</vs-th>
                <vs-th>Quote level</vs-th>
                <vs-th>Worst line</vs-th>
                <vs-th>Why it can still make sense</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(qt, indextr) in data" :key="qt.idoperation" :data="qt" :title="priceCheckQuoteTitle(qt)">
                  <vs-td>
                    <!-- Same number as the « Orders in progress » list and the quote page: the operation id -->
                    <a :href="pcQuoteHref(qt)" class="text-inherit" style="text-decoration: underline;"
                      @click.exact.prevent="openPriceCheckQuote(qt)">
                      <b>#{{ qt.idoperation }}</b>
                    </a>
                    <br /><small style="color: #999;">{{ qt.zone }} · {{ qt.edition_label }}</small>
                  </vs-td>
                  <vs-td>{{ qt.client_name }}</vs-td>
                  <vs-td>
                    <span v-if="qt.idbroker">{{ qt.broker_name || ('#' + qt.idbroker) }}</span>
                    <span v-else style="color: #bbb;">—</span>
                  </vs-td>
                  <vs-td>{{ pcDate(qt.operation_date) }}</vs-td>
                  <vs-td>
                    <span :class="qt.off_level ? 'text-warning' : ''"><b>{{ pcQuoteLevel(qt) }}</b></span>
                    <br /><small style="color: #999;">{{ qt.quote_applicable }}/{{ qt.quote_lines }} comparable</small>
                  </vs-td>
                  <vs-td>
                    <template v-if="qt.worst">
                      <span :class="qt.errors > 0 ? 'text-danger' : (qt.worst.severity === 'diff' ? 'text-warning' : '')"><b>{{ pcWorstDelta(qt.worst) }}</b></span>
                      <span v-if="qt.errors > 1" class="text-danger"> (+{{ qt.errors - 1 }} more)</span>
                      <br /><small style="color: #999;">{{ (qt.worst.product_name || '').slice(0, 48) }} · {{ pcMoney(qt.worst.quoted_eur) }} vs {{ qt.worst.expected_eur != null ? pcMoney(qt.worst.expected_eur) : '—' }}</small>
                    </template>
                  </vs-td>
                  <!-- What the invoices and the catalogue say about the worst line's gap (server text) -->
                  <vs-td>
                    <div v-if="qt.worst && qt.worst.why && qt.worst.why.reasons.length" class="pc-why-row">
                      <!-- ✓ every line off the catalogue is explained · ✗ at least one is not -->
                      <span v-if="qt.explained != null" class="pc-badge" :class="qt.explained ? 'pc-badge-ok' : 'pc-badge-ko'"
                        :title="qt.explained ? 'Every price off the catalogue has an explanation' : 'At least one price off the catalogue has no explanation'">
                        <feather-icon :icon="qt.explained ? 'CheckIcon' : 'XIcon'" svgClasses="h-4 w-4" />
                      </span>
                      <div class="pc-why">
                        <span :class="pcWhyClass(qt.worst)">{{ qt.worst.why.reasons[0].text }}</span>
                        <small v-if="qt.worst.why.reasons[1]" class="pc-why-more">{{ qt.worst.why.reasons[1].text }}</small>
                        <small v-if="qt.worst.why.caveat" class="text-warning">
                          <feather-icon icon="AlertTriangleIcon" svgClasses="h-3 w-3" class="mr-1" />{{ qt.worst.why.caveat }}
                        </small>
                        <small v-if="qt.other_flagged > 0" class="pc-why-more">
                          +{{ qt.other_flagged }} other line{{ qt.other_flagged === 1 ? '' : 's' }} off catalogue, {{ qt.other_explained === qt.other_flagged ? 'all' : qt.other_explained }} explained
                        </small>
                      </div>
                    </div>
                    <span v-else style="color: #bbb;">—</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>

            <!-- Footer: when, what was skipped -->
            <div class="mt-3" style="text-align: right;">
              <small style="color: #b8b8b8;">
                {{ priceCheckQuotes }} order{{ priceCheckQuotes === 1 ? '' : 's' }} checked {{ pcChecked }}<span v-if="priceCheckEditions"> · catalogue {{ priceCheckEditions }}</span><span v-if="priceCheckNoZone > 0"> · {{ priceCheckNoZone }} without incoterm</span><span v-if="priceCheckInfoOnly > 0"> · {{ priceCheckInfoOnly }} not comparable</span>
              </small>
            </div>
          </div>
        </vs-popup>

        <!-- Casa de Marcat — bons fiscaux Datecs.
             Carte distincte de eInvoice : une facture électronique et un bon
             fiscal de caisse sont deux documents différents, avec des
             obligations différentes. Les mélanger dans une seule tuile ferait
             croire qu'un eFactura envoyé dispense du bon fiscal.

             Le compteur qui compte ici est « needs review » : un bon
             indéterminé (BONOK=-1 ou pas de réponse) a PEUT-ÊTRE imprimé, et
             tant qu'un humain n'a pas lu le journal de la caisse, la facture
             reste bloquée. Ce n'est pas une erreur de plus dans une liste,
             c'est une tâche du jour. -->
        <vx-card title="Casa de Marcat" class="mb-0" v-if="isAdmin || isModerator">
          <div slot="no-body" class="p-5 mt-0 ml-4 mr-4 mb-4">
            <div class="vx-row justify-center">

              <!-- SANS CORRESPONDANCE DE TVA, RIEN NE PEUT SORTIR.
                   Affiché en premier et en danger : c'est un blocage total, pas
                   un réglage optionnel. La caisse attend un numéro de groupe
                   (1 à 5), et son taux n'est lisible que sur un rapport X. -->
              <vs-chip v-if="fiscalVatGroups === 0" color="danger">
                <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/settings/fiscal-config' }" class="text-inherit">
                  VAT groups not declared — no receipt can be issued
                </router-link>
              </vs-chip>

              <!-- ETAT DE L'AGENT, EN PERMANENCE.
                   La premiere version ne l'affichait que s'il bloquait
                   quelque chose, pour eviter la fatigue d'alerte. Mais on ne
                   pouvait alors pas repondre a « est-ce que ca tourne ? »
                   depuis le dashboard, qui est justement l'ecran ou on
                   regarde. Compromis retenu : toujours visible, severite
                   croissante — vert discret quand tout va, rouge quand des
                   bons attendent pour rien. -->
              <vs-chip v-if="fiscalAgentOnline" color="success">
                <feather-icon icon="WifiIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/fiscal-jobs' }" class="text-inherit">
                  Casa de Marcat agent online<span v-if="fiscalRegister && fiscalRegister.level === 'ok' && fiscalAgent && fiscalAgent.register_probe"> · register {{ fiscalAgent.register_probe.found_ip }}</span>
                </router-link>
              </vs-chip>
              <vs-chip v-else :color="fiscalAgentBlocking ? 'danger' : 'warning'">
                <feather-icon icon="WifiOffIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/fiscal-jobs' }" class="text-inherit">
                  <span v-if="fiscalAgentBlocking">
                    Agent offline — {{ fiscalPending }} receipt(s) will not print
                  </span>
                  <span v-else-if="fiscalAgent">Agent offline</span>
                  <span v-else>Agent never installed</span>
                </router-link>
              </vs-chip>

              <!-- LA CAISSE ELLE-MEME : injoignable, IP changee, ou hors mode 6.
                   Distinct de l'agent : le 18/09 l'agent etait en ligne et la
                   caisse, passee a une autre IP, ne recevait plus rien. -->
              <vs-chip v-if="fiscalRegister && fiscalRegister.level === 'danger'" color="danger">
                <feather-icon icon="AlertOctagonIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/settings/fiscal-config' }" class="text-inherit">
                  {{ fiscalRegister.message }}
                </router-link>
              </vs-chip>

              <!-- INDÉTERMINÉ : arbitrage humain requis -->
              <vs-chip v-if="fiscalIndeterminate > 0" color="danger">
                <feather-icon icon="HelpCircleIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/fiscal-jobs' }" class="text-inherit">
                  Needs review: {{ fiscalIndeterminate }}
                </router-link>
              </vs-chip>

              <!-- RAPPORT Z OUBLIE : des ventes d'un jour precedent ne sont pas
                   cloturees. Le cron du soir le fait d'office ; s'il est
                   affiche, c'est que la caisse ou l'agent etaient absents. -->
              <vs-chip v-if="fiscalZ && fiscalZ.overdue" color="danger">
                <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/settings/fiscal-config' }" class="text-inherit">
                  Z report missing — sales since {{ fiscalDay(fiscalZ.oldest_unclosed_at) }} not closed
                </router-link>
              </vs-chip>

              <!-- Z AU RESULTAT INCONNU : jamais rejoue tout seul -->
              <vs-chip v-if="fiscalZ && fiscalZ.unknown_job_id" color="warning">
                <feather-icon icon="HelpCircleIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/fiscal-jobs' }" class="text-inherit">
                  Z report to verify (job #{{ fiscalZ.unknown_job_id }})
                </router-link>
              </vs-chip>

              <!-- EN ATTENTE D'IMPRESSION -->
              <vs-chip v-if="fiscalPending > 0" color="warning">
                <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/fiscal-jobs' }" class="text-inherit">
                  Waiting to print: {{ fiscalPending }}
                </router-link>
              </vs-chip>

              <!-- TOUT EST CALME. Même formulation rassurante que la tuile
                   eInvoice, pour que « rien à faire » se lise au premier coup
                   d'œil au lieu d'une tuile vide ambiguë. -->
              <vs-chip
                v-if="fiscalVatGroups > 0 && fiscalIndeterminate === 0 && fiscalPending === 0 && !(fiscalZ && (fiscalZ.overdue || fiscalZ.unknown_job_id)) && !(fiscalRegister && fiscalRegister.level === 'danger')"
                color="success"
              >
                <feather-icon icon="PrinterIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/fiscal-jobs' }" class="text-inherit">
                  All fiscal receipts have been printed
                </router-link>
              </vs-chip>

              <!-- DERNIER Z, pour repondre d'un coup d'oeil a « la caisse a-t-elle
                   cloture hier ? ». La transmission a l'ANAF, elle, est faite par
                   la caisse et n'est pas visible d'ici. -->
              <!-- Toujours affichee des que l'etat est charge : « aucun Z » est
                   une information, pas une absence d'information. -->
              <vs-chip v-if="fiscalZ" color="primary">
                <feather-icon icon="LockIcon" svgClasses="h-4 w-4" class="mr-1" />
                <router-link :to="{ path: '/settings/fiscal-config' }" class="text-inherit">
                  <span v-if="fiscalZ.last_at">
                    Last Z report sent: {{ fiscalDateTime(fiscalZ.last_at) }}<span v-if="fiscalZ.last_no"> (n° {{ fiscalZ.last_no }})</span>
                  </span>
                  <span v-else>Last Z report sent: none yet</span>
                </router-link>
              </vs-chip>

            </div>
          </div>
        </vx-card>

        <vx-card title="Live attendance" class="mb-0">
          <div slot="no-body" class="mt-0 ml-4 mr-4 mb-4">
            <!-- Currently on site (source: XYLO-ATTENDANCE), clickable to the attendance app -->
            <div v-if="currentlyworking.length > 0">
              <div
                v-for="(p, i) in currentlyworking"
                :key="i"
                class="flex items-center justify-between py-2"
                style="border-bottom: 1px solid #eee; cursor: pointer;"
                @click="openAttendance">
                <span>
                  <feather-icon icon="UserCheckIcon" svgClasses="h-4 w-4 text-success" class="mr-2" />
                  <b>{{ p.first_name }} {{ p.last_name }}</b>
                </span>
                <small style="color:#888;">since {{ checkInTime(p.check_in_at) }} ({{ presenceDuration(p.check_in_at) }})</small>
              </div>
            </div>

            <!-- Pending leave requests — kept discreet -->
            <div class="mt-3" style="text-align: right;">
              <small class="cursor-pointer" style="color:#b8b8b8;" @click="openAttendance">
                {{ pendingLeaveCount }} pending leave request{{ pendingLeaveCount === 1 ? '' : 's' }}
              </small>
            </div>
          </div>
        </vx-card>
        <vx-card class="mb-8">
          <vs-tabs>
            <vs-tab label="Future departures " icon-pack="feather" icon="icon-truck">
              <div class="mt-4" style="border">
                <vs-table v-if="transportwaitingfordeparture" ref="table2" :data="transportwaitingfordeparture">
                  <div slot="header" class="
                  flex flex-wrap-reverse
                  items-center
                  flex-grow
                  justify-between
                ">
                    <div class="
                    flex flex-wrap-reverse
                    items-center
                    data-list-btn-container
                  "></div>
                  </div>

                  <template slot="thead"> </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :key="indexatr1" v-for="(tr, indexatr1) in data">
                        <vs-td>
                          <vs-chip v-if="tr.id" class="ag-grid-cell-chips" color="#AAA">
                            <router-link v-if="tr.id" :to="{
                              path: '/transport/' + tr.id,
                            }" class="text-inherit" :style="{ textDecoration: 'underline' }">
                              <span>{{ tr.id }}</span></router-link>

                            &nbsp;
                            <feather-icon icon="TruckIcon" svgClasses="h-5 w-5" />
                            <span v-if="tr.transporter" class="ml-1"><small>{{ tr.transporter.slice(0, 10)
                            }}...</small></span>
                            <span v-else class="ml-1" :style="{ color: 'white' }"><small>No Transporter</small></span>
                          </vs-chip>
                        </vs-td>
                        <vs-td><small :style="{ verticalAlign: 'top' }">{{
                          displayDateddMMyyyy(tr.date)
                            }}</small></vs-td>

                        <vs-td>
                          <vs-chip v-if="tr.client" class="ag-grid-cell-chips" color="">
                            <img height="20px" v-if="tr.destinationcode == 'BE'" src="@/assets/images/flags/BE.png"
                              alt="BE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'HU'" src="@/assets/images/flags/HU.png"
                              alt="HU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'AT'" src="@/assets/images/flags/AT.png"
                              alt="AT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'NL'" src="@/assets/images/flags/NL.png"
                              alt="NL" />
                            <img height="20px" v-else-if="tr.destinationcode == 'CH'" src="@/assets/images/flags/CH.png"
                              alt="CH" />
                            <img height="20px" v-else-if="tr.destinationcode == 'DE'" src="@/assets/images/flags/DE.png"
                              alt="DE" />
                            <img height="20px" v-else-if="tr.destinationcode == 'ES'" src="@/assets/images/flags/ES.png"
                              alt="ES" />
                            <img height="20px" v-else-if="tr.destinationcode == 'FR'" src="@/assets/images/flags/FR.png"
                              alt="FR" />
                            <img height="20px" v-else-if="tr.destinationcode == 'IT'" src="@/assets/images/flags/IT.png"
                              alt="IT" />
                            <img height="20px" v-else-if="tr.destinationcode == 'LU'" src="@/assets/images/flags/LU.png"
                              alt="LU" />
                            <img height="20px" v-else-if="tr.destinationcode == 'RO'" src="@/assets/images/flags/RO.png"
                              alt="RO" />
                            <img height="20px" v-else-if="tr.destinationcode == 'GB'" src="@/assets/images/flags/UK.png"
                              alt="GB" />
                            <img height="20px" v-else-if="tr.destinationcode == 'PT'" src="@/assets/images/flags/PT.png"
                              alt="PT" />
                            <img height="20px" v-else src="@/assets/images/flags/UE.png" alt="EU" />

                            &nbsp;{{ tr.client.slice(0, 50) }}...</vs-chip>
                          <vs-chip v-else class="ag-grid-cell-chips" color="">
                            Client not selected</vs-chip>
                        </vs-td>
                        <vs-td>
                          <feather-icon v-if="quotation_dashboard_product.length > 0" icon="PackageIcon"
                            svgClasses="h-5 w-5" @click="openThePopupTransport(tr)" :style="{ cursor: 'pointer' }" />
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>



            </vs-tab>
            <vs-tab :label=getTitleRight() icon-pack="feather" icon="icon-package">
              <vs-button v-if="quotation_dashboard_product_print_v3.length == 0" ref="loadableButton"
                id="button-with-loading" class="mt-4 mb-4 vs-con-loading__container" color="black" :style="{ width: '100%' }"
                @click="LoadProductToBeDone" type="relief">
                Load
              </vs-button>
              <div class="mt-4" style="border" v-if="quotation_dashboard_product_print.length > 0">
                <vs-table ref="table" :data="quotation_dashboard_product_print" search :max-items="1000">
                  <div slot="header" class="
                  flex flex-wrap-reverse
                  items-center
                  flex-grow
                  justify-between
                ">
                    <div class="
                    flex flex-wrap-reverse
                    items-center
                    data-list-btn-container
                  "></div>
                  </div>

                  <template slot="thead">
                    <vs-th>Product Name</vs-th>
                    <vs-th sort>Delivery Date</vs-th>
                    <vs-th :style="{ textAlign: 'right' }">Quantity</vs-th>
                    <vs-th :style="{ textAlign: 'right' }">Volume (m3)</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <tbody>
                      <vs-tr :key="indexatr" v-for="(tr, indexatr) in data">
                        <vs-td>
                          <span :style="{ fontSize: '75%' }">
                            <router-link :to="{ path: '/stock/' + data[indexatr].idproduct }" class="text-inherit"><b>{{
                              data[indexatr].categoryro }}</b> <br />
                              {{ data[indexatr].productro }}</router-link>
                          </span>
                        </vs-td>
                        <vs-td :style="{ fontSize: '75%' }">
                          {{ data[indexatr].date_delivery_desired.substring(0, 10)
                          }}
                        </vs-td>
                        <vs-td :style="{ textAlign: 'right', fontSize: '85%' }">
                          {{
                            Math.abs(
                              parseFloat(data[indexatr].volumetoprepare).toFixed(2)
                            )
                          }}
                          {{ data[indexatr].uom }}
                        </vs-td>
                        <vs-td :style="{ textAlign: 'right', float: 'right' }">
                          <vs-chip class="ag-grid-cell-chips" color="danger"
                            v-if="parseFloat(data[indexatr].volumetoprepare) >= 5">
                            {{
                              Math.abs(
                                parseFloat(data[indexatr].volumetoprepare).toFixed(
                                  2
                                )
                              )
                            }} m3
                          </vs-chip>

                          <vs-chip class="ag-grid-cell-chips" color="warning"
                            v-else-if="parseFloat(data[indexatr].volumetoprepare) < 5">
                            {{
                              Math.abs(
                                parseFloat(data[indexatr].volumetoprepare).toFixed(
                                  2
                                )
                              )
                            }} m3
                          </vs-chip>

                          <vs-chip class="ag-grid-cell-chips" color="" v-else>
                            N/A
                          </vs-chip>
                        </vs-td>
                      </vs-tr>
                    </tbody>
                  </template>
                </vs-table>
              </div>
            </vs-tab>
            <vs-tab label='Print' icon-pack="feather" icon="icon-printer">
              <h4 class="mt-8">Print to be produced table</h4>
              <vs-button id="button-grouped-by-product" class="mt-4 vs-con-loading__container" color="black"
                :style="{ width: '100%' }" @click="GenerateDocumentInternalLoadingv2" type="relief">
                GROUPED BY PRODUCT
              </vs-button>

              <vs-button id="button-sorted-by-category" class="mt-4 vs-con-loading__container" color="black"
                :style="{ width: '100%' }" @click="GenerateDocumentInternalLoadingv3" type="relief">
                SORTED BY CATEGORY
              </vs-button>

              <vs-button id="button-sorted-by-quotation" class="mt-4 mb-4 vs-con-loading__container" color="black"
                :style="{ width: '100%' }" @click="GenerateDocumentInternalLoading" type="relief">
                SORTED BY QUOTATION
              </vs-button>
            </vs-tab>
          </vs-tabs>
        </vx-card>

        <vx-card title="Sumal Sync" class="mb-0">
          <div slot="no-body" class="mt-0 ml-4 mr-4 mb-4">
            <vs-table :data="sumal_dashboard" class="table-dark-inverted" :style="{ width: '100%' }" search>
              <template slot="thead">
                <vs-th :style="{ fontSize: '75%' }">Type</vs-th>
                <vs-th :style="{ fontSize: '75%' }">Aviz No</vs-th>
                <vs-th :style="{ fontSize: '75%' }">Sumal Date</vs-th>
                <vs-th :style="{ fontSize: '75%' }">Weight</vs-th>
                <vs-th :style="{ fontSize: '75%' }">Volume</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextrr" v-for="(tr, indextrr) in data" :style="{ fontSize: '75%' }">
                        <vs-td>
                    <span> {{ tr.name_en }} </span>
                  </vs-td>
                  <vs-td><span>
                      <a :href="generatedUrl(tr.name_en, tr.id)">
                        {{ tr.sumal_aviz_nr }}
                      </a>
                    </span>
                  </vs-td>
                        <vs-td>
                    <span> {{ displayDateddMMyyyy(tr.sumaldate) }} </span>
                  </vs-td>
                  <vs-td>
                    <span v-if="tr.transport_tonaj"> {{ tr.transport_tonaj }} t </span>
                    <span v-else> - </span>
                  </vs-td>
                  <vs-td>
                    <span> {{ parseFloat(tr.volume).toFixed(2) }} m3</span>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-popup fullscreen :title="OpenedPopupTitle" :active.sync="popupActive">
      <vs-alert
        v-if="popupRow && popupRow.pending_admin_validation"
        color="warning" icon-pack="feather" icon="icon-clock" :active="true" class="mb-6">
        <div class="flex items-center justify-between" style="width:100%;">
          <span>This quotation was approved by a broker and requires your final validation before it can move forward.</span>
          <vs-button
            v-if="isApprovalAdmin"
            color="warning"
            size="small"
            class="ml-4"
            @click="openPendingApprovalPopup(popupRow)">
            PENDING TO APPROVE
          </vs-button>
        </div>
      </vs-alert>
      <vs-alert class="mb-8" color="warning" title="Internal Note" active="true" v-if="popup_mail_top">
        <div v-html="'' + popup_mail_top"></div>
      </vs-alert>
      <vs-table :data="popup_quotation_dashboard_product">
        <template slot="thead">
          <vs-th :style="{ fontSize: '100%' }">Quotation Ref.</vs-th>
          <vs-th :style="{ fontSize: '100%' }">Quantity * Product Name</vs-th>
          <vs-th :style="{ fontSize: '100%' }">Current Stock</vs-th>
          <vs-th :style="{ fontSize: '100%' }">Allocated Stock</vs-th>
          <vs-th :style="{ fontSize: '100%' }">Available Stock</vs-th>
          <vs-th :style="{ fontSize: '100%' }">Remaining Stock</vs-th>
          <vs-th :style="{ fontSize: '100%' }">To be prepared</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextrr" v-for="(tr, indextrr) in data" :style="{ fontSize: '100%' }">
            <vs-td v-if="tr.category != 'Services'
            ">
              <span>#{{ tr.quotationref }}</span>
            </vs-td>
            <vs-td v-if="tr.category != 'Services'">
              <span v-if="tr.volume">
                {{
                  Math.abs(
                    parseFloat(tr.stock_apres) - parseFloat(tr.stock_avant)
                  ).toFixed(2)
                }}
                {{ tr.uom }} * {{ tr.category }}
                {{ tr.product }} →
                {{
                  Math.abs(
                    parseFloat(
                      parseFloat(tr.stock_apres) -
                      parseFloat(tr.stock_avant)
                    ) * parseFloat(tr.volume)
                  ).toFixed(2)
                }}
                m3
              </span>
              <span v-else>
                {{
                  Math.abs(
                    parseFloat(tr.stock_apres) - parseFloat(tr.stock_avant)
                  ).toFixed(2)
                }}
                {{ tr.uom }} * {{ tr.category }}
                {{ tr.product }}
              </span>
            </vs-td>

            <vs-td v-if="tr.category != 'Services'
            ">
              <span>{{ parseFloat(tr.currentstock).toFixed(2) }} {{ tr.uom }}</span>
            </vs-td>
            <vs-td v-if="tr.category != 'Services'
            ">
              <span>{{
                Math.abs(
                  parseFloat(tr.stock_avant) - parseFloat(tr.currentstock)
                ).toFixed(2)
              }}
                {{ tr.uom }}</span>
            </vs-td>

            <vs-td v-if="tr.category != 'Services'
            ">
              <span>{{ parseFloat(tr.stock_avant).toFixed(2) }} {{ tr.uom }}</span>
            </vs-td>
            <vs-td v-if="tr.category != 'Services'
            ">
              <span v-if="tr.volume && parseFloat(tr.stock_apres) >= 0" :style="{ color: 'green' }">{{
                parseFloat(tr.stock_apres).toFixed(2)
              }} {{ tr.uom }}

                ({{ Math.abs(
                  parseFloat(tr.stock_apres) * parseFloat(tr.volume)
                ).toFixed(2)
                }}
                m3)</span>
              <span v-else-if="parseFloat(tr.stock_apres) >= 0" :style="{ color: 'green' }">{{
                parseFloat(tr.stock_apres).toFixed(2)
              }} {{ tr.uom }}</span>
              <span v-else>N/A</span>
            </vs-td>

            <vs-td v-if="tr.category != 'Services'
            ">

              <!--CURRENT STOCK {{ parseFloat(tr.stock_avant).toFixed(2) }}
              COMMANDE {{ Math.abs(parseFloat(tr.stock_apres) - parseFloat(tr.stock_avant)).toFixed(2) }}-->
              <span v-if="parseFloat(tr.stock_avant) < 0" :style="{ color: 'red' }">
                {{ Math.abs((parseFloat(tr.stock_apres) - parseFloat(tr.stock_avant))).toFixed(2) }} {{ tr.uom }}
                ({{ Math.abs((parseFloat(tr.stock_apres) - parseFloat(tr.stock_avant)) * parseFloat(tr.volume)).toFixed(2)
                }} m3)
                <feather-icon icon="ZapIcon" svgClasses="h-5 w-5 cursor-pointer" @click="addToProductionPending(tr)" />
              </span>

              <span v-else-if="parseFloat(tr.stock_apres) < 0" :style="{ color: 'red' }">
                {{
                  Math.abs(parseFloat(tr.stock_apres)).toFixed(2) }} {{ tr.uom }} ({{
                  Math.abs(
                    parseFloat(tr.stock_apres) * parseFloat(tr.volume)
                  ).toFixed(2)
                }}
                m3)
                <feather-icon icon="ZapIcon" svgClasses="h-5 w-5 cursor-pointer" @click="addToProductionPending(tr)" />
              </span>
              <span v-else>N/A</span>





              <!--
              <span v-if="parseFloat(tr.stock_apres) < 0" style="color: red">
                {{
                Math.abs(parseFloat(tr.stock_apres)).toFixed(2) }} {{ tr.uom }} ({{
                  Math.abs(
                    parseFloat(tr.stock_apres) * parseFloat(tr.volume)
                  ).toFixed(2)
                }}
                m3)
                <feather-icon icon="ZapIcon" svgClasses="h-5 w-5 cursor-pointer" @click="addToProductionPending(tr)" />-->
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <!-- POPUP ALERT  -->
    <vs-popup class="holamundo" title="Alert" :active.sync="popupDescription">
      <div v-html="dataModelDescription"></div>
      <div v-html="createdDate"></div>
      <div v-html="updatedDate"></div>
    </vs-popup>
    <!-- POPUP PENDING APPROVAL (broker quotation awaiting admin validation) -->
    <vs-popup
      class="pending-approval-popup"
      title="Approve broker quotation"
      :active.sync="popupPendingApproval">
      <div v-if="pendingApprovalRow" class="p-2">
        <vs-alert color="warning" icon-pack="feather" icon="icon-clock" :active="true" class="mb-4">
          This quotation was approved by a broker and requires your final validation.
        </vs-alert>
        <p class="mb-2">
          Quotation <b>#{{ pendingApprovalRow.quotationref }}</b>
          &mdash; client <b>{{ pendingApprovalRow.client }}</b>
        </p>
        <p class="mb-4" v-if="pendingApprovalRow.volume != null">
          Volume: <b>{{ Math.abs(pendingApprovalRow.volume).toFixed(2) }} m³</b>
        </p>
        <div class="flex justify-end mt-4">
          <vs-button type="border" color="danger" class="mr-2"
            @click="popupPendingApproval = false"
            :disabled="pendingApprovalSubmitting">
            Cancel
          </vs-button>
          <vs-button color="success"
            @click="confirmPendingApproval"
            :disabled="pendingApprovalSubmitting">
            Approve
          </vs-button>
        </div>
      </div>
    </vs-popup>
    <FloatingProduction :productions="productionDone" @update-productions="removeFromProduction"
      @production-done="afterProductionSaved" v-if="productionDone.length > 0" />
  </div>
</template>

<script>
import FloatingProduction from "./components/FloatingProduction.vue";
import { landingPathFor } from "@/helpers/roleAccess.js";
import VueApexCharts from "vue-apexcharts";
import moment from "moment";
import vSelect from "vue-select";
const themeColors = ["#28C76F", "#EA5455", "#EA5455", "#FF9F43", "#1E1E1E"];
import axios from "@/axios.js";
import moduleDataListDashboard from "@/store/dashboard/moduleOperationList.js";
import { AmiriRegular } from "@/assets/fonts/Amiri-Regular-normal.js";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  data() {
    return {
      isAdmin: false,
      // Moderator : voit la tuile Casa de Marcat (pas eInvoice).
      isModerator: false,
      loadingText: "Loading Orders: 0%",
      isLoadingEFactura: null,
      backgroundLoading: "primary",
      colorLoading: "#fff",
      isLoading: false,
      productionDone: [],
      updatedDate: null,
      createdDate: null,
      OpenedPopupTitle: null,
      popupRow: null,
      popupDescription: false,
      dataModelDescription: "1. The quotation was edited within the past <b>4 days.</b> <br/>2; The time difference between the quotation's creation date and its most recent edit <b>is greater than 24 hours.</b><br/><br/>",
      popup_mail_top: null,
      popup_quotation_dashboard_product: [],
      popupActive: false,
      popupPendingApproval: false,
      pendingApprovalRow: null,
      pendingApprovalSubmitting: false,
      // 2FA reminder popup — shown once on dashboard mount if user hasn't
      // enabled 2FA yet. Will become hard-block on/after May 31, 2026.
      show2faPrompt: false,
      itemsPerPage: 25,
      toberefreshed: false,
      selected: [],
      seconds: 59,
      isMounted: false,
      center: { lat: 50.0, lng: 12.0 },
      markers: [],
      // Charge la carte Google uniquement sur clic utilisateur, pour éviter
      // un "Map Load" facturable à chaque ouverture du dashboard.
      showMap: false,
      boundRating: 0,

      purchaseOrdersList: [],
      quotationList: [],
      quotationProductList: [],
      saleList: [],
      evolutionStock: {},
      valuePiquet: [],
      valueBrut: [],
      isGraphFailed: true,
      activePrompt2: false,
      quotationRefClickedPrompt2: null,
      vartotalVolumeReady: 0,
      currentlyworking: [],
      pendingLeaveCount: 0,
      // Price check (test phase) — admins and moderators. null = not loaded yet; priceCheckError = why it failed.
      priceCheck: null,
      priceCheckError: null,
      priceCheckOpen: false,
      priceCheckHelp: false,

      greenIcon: "http://maps.google.com/mapfiles/kml/paddle/grn-blank.png",
      whiteIcon: "http://maps.google.com/mapfiles/kml/paddle/wht-blank.png",
      blueIcon: "http://maps.google.com/mapfiles/kml/paddle/blu-blank.png",
    };
  },
  computed: {
    canPriceCheck() {
      return this.isAdmin || this.isModerator;
    },
    priceCheckCounts() {
      return (this.priceCheck && this.priceCheck.counts) || {};
    },
    priceCheckQuotesErrors() {
      return Number(this.priceCheckCounts.quotes_with_errors) || 0;
    },
    priceCheckQuotesOff() {
      return Number(this.priceCheckCounts.quotes_off_level) || 0;
    },
    priceCheckQuotes() {
      return Number(this.priceCheckCounts.quotes) || 0;
    },
    priceCheckNoZone() {
      return Number(this.priceCheckCounts.quotes_no_zone) || 0;
    },
    priceCheckInfoOnly() {
      return Number(this.priceCheckCounts.quotes_info_only) || 0;
    },
    // Which price editions the lines were compared with, e.g. "2026" or "2026, 2026 ÷ 1.05".
    priceCheckEditions() {
      const ed = this.priceCheckCounts.editions;
      return ed && typeof ed === "object" ? Object.keys(ed).join(", ") : "";
    },
    pcChecked() {
      return this.priceCheck && this.priceCheck.computed_at ? moment(this.priceCheck.computed_at).format("DD/MM HH:mm") : "";
    },
    priceCheckRows() {
      return (this.priceCheck && this.priceCheck.quotes) || [];
    },
    getefacturareceived() {
      return this.$store.state.dataListDashboard.eFacturaReceived;
    },
    getefacturatobesent() {
      return this.$store.state.dataListDashboard.eFacturaToBeSent;
    },
    // Casa de marcat. `fiscalVatGroups` a 0 = correspondance GRTVA -> taux non
    // declaree, donc aucun bon ne peut sortir : la tuile doit l'annoncer.
    fiscalPending() {
      return this.$store.state.dataListDashboard.fiscalPending;
    },
    fiscalIndeterminate() {
      return this.$store.state.dataListDashboard.fiscalIndeterminate;
    },
    fiscalVatGroups() {
      return this.$store.state.dataListDashboard.fiscalVatGroups;
    },
    fiscalAgentBlocking() {
      return this.$store.state.dataListDashboard.fiscalAgentBlocking;
    },
    fiscalAgent() {
      return this.$store.state.dataListDashboard.fiscalAgent;
    },
    fiscalZ() {
      return this.$store.state.dataListDashboard.fiscalZ;
    },
    fiscalRegister() {
      return this.$store.state.dataListDashboard.fiscalRegister;
    },
    fiscalAgentOnline() {
      const a = this.fiscalAgent;
      // `stale` est calcule par le serveur (5 min de silence). On exige aussi
      // status !== 'error' : un agent qui repond mais ne trouve pas ses
      // dossiers ne doit pas s'afficher en vert.
      return !!a && !a.stale && a.status !== 'error';
    },
    transportwaitingfordeparture() {
      return this.$store.state.dataListDashboard.transportwaitingfordeparture || [];
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    sumal_dashboard() {
      return this.$store.state.dataListDashboard.sumal_dashboard || [];
    },
    quotation_dashboard() {
      this.markers = this.$store.state.dataListDashboard.quotation_dashboard;
      this.totalVolumeReady();
      return this.$store.state.dataListDashboard.quotation_dashboard || [];
    },
    quotation_dashboard_product() {
      return this.$store.state.dataListDashboard.quotation_dashboard_product || [];
    },
    quotation_dashboard_product_print() {
      return this.$store.state.dataListDashboard.quotation_dashboard_product_print || [];
    },
    quotation_dashboard_product_print_v2() {
      return this.$store.state.dataListDashboard.quotation_dashboard_product_print_v2 || [];
    },
    quotation_dashboard_product_print_v3() {
      return this.$store.state.dataListDashboard.quotation_dashboard_product_print_v3 || [];
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.quotation_dashboard.length;
    },
    isApprovalAdmin() {
      const u = localStorage.getItem("login-username");
      return u === "Denis" || u === "Ferdinand" || u === "Clément" || u === "Chady";
    },
  },
  components: {
    VueApexCharts,
    FloatingProduction
  },
  methods: {
    // Dates de la tuile Casa de Marcat : format court, heure locale du poste.
    fiscalDay(value) {
      const d = value ? new Date(value) : null;
      if (!d || Number.isNaN(d.getTime())) return '?';
      const pad = (n) => String(n).padStart(2, '0');
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
    },
    fiscalDateTime(value) {
      const d = value ? new Date(value) : null;
      if (!d || Number.isNaN(d.getTime())) return '?';
      const pad = (n) => String(n).padStart(2, '0');
      return `${this.fiscalDay(value)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    check2faStatus() {
      // Decide synchronously from the login-time cache so the popup shows on
      // first mount instead of racing the /2fa/status request against the
      // dashboard's many parallel API calls (which on a slow network can let
      // a 401 redirect or component swap kill the popup before it appears).
      // If the cache is missing we fall back to the API.
      const must = !!localStorage.getItem("xylo:must-enable-2fa");
      let cachedDisabled = false;
      try {
        const raw = localStorage.getItem("xylo:twofa-status");
        if (raw) cachedDisabled = JSON.parse(raw).twofa_enabled === false;
      } catch (e) { /* ignore parse errors */ }
      if (must || cachedDisabled) {
        this.$nextTick(() => { this.show2faPrompt = true; });
        return;
      }
      // No cache → ask the server. Silent on failure.
      axios.get("/auth/2fa/status")
        .then((res) => {
          if (res && res.data && res.data.twofa_enabled === false) {
            this.show2faPrompt = true;
          }
        })
        .catch(() => {});
    },
    goTo2faSetup() {
      this.show2faPrompt = false;
      this.$router.push({ path: "/configurations/edit-profil", query: { tab: "security" } }).catch(() => {});
    },
    openPendingApprovalPopup(row) {
      this.pendingApprovalRow = row;
      this.popupPendingApproval = true;
    },
    confirmPendingApproval() {
      if (!this.pendingApprovalRow || this.pendingApprovalSubmitting) return;
      this.pendingApprovalSubmitting = true;
      const quotationRef =
        this.pendingApprovalRow.quotationref || this.pendingApprovalRow.id;
      axios.post("/quotation/validatebrokerapproval", {
        // The dashboard row exposes the operation id as `quotationref`
        // (quotationref: quotation.id); there is no separate `.id` field.
        id: this.pendingApprovalRow.id || this.pendingApprovalRow.quotationref,
        who: localStorage.getItem("login-username"),
      })
        .then((response) => {
          // The server sends the "quotation approved" e-mail to the broker
          // itself (broker's language, link to the quotation) and reports it.
          this.notifyBrokerApprovalMail(response && response.data, quotationRef);
          this.popupPendingApproval = false;
          this.pendingApprovalRow = null;
          // Close the products popup too — the quotation is no longer pending.
          this.popupActive = false;
          this.popupRow = null;
          this.$store.dispatch("dataListDashboard/fetchQuotation");
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Approval failed",
            text: (err && err.message) || "Unable to validate this quotation.",
          });
        })
        .then(() => {
          this.pendingApprovalSubmitting = false;
        });
    },
    // Outcome of the validation + of the broker e-mail sent by the server
    // (POST /quotation/validatebrokerapproval → { ok, mail }). The e-mail is
    // never blocking: the quotation is validated even when it was not sent.
    notifyBrokerApprovalMail(data, quotationRef) {
      const mail = (data && data.mail) || null;
      if (data && data.alreadyValidated) {
        this.$vs.notify({
          color: "primary",
          title: "Already validated",
          text: `Quotation #${quotationRef} had already been validated. No e-mail sent.`,
          time: 8000,
        });
        return;
      }
      if (mail && mail.sent) {
        this.$vs.notify({
          color: "success",
          title: "Approved",
          text: `Quotation #${quotationRef} validated. Broker notified by e-mail (${(mail.to || []).join(", ")}, ${String(mail.lang || "en").toUpperCase()}).`,
          time: 8000,
        });
        return;
      }
      const reasons = {
        no_broker: "this quotation has no broker",
        broker_inactive: "the broker's record is inactive",
        broker_no_email: "the broker has no e-mail address on their record",
        not_found: "the quotation was not found",
        smtp_error: `SMTP error${mail && mail.error ? ` (${mail.error})` : ""}`,
      };
      const reason = (mail && (reasons[mail.reason] || mail.error || mail.reason)) || "unknown reason";
      this.$vs.notify({
        color: "warning",
        title: "Approved, broker not notified",
        text: `Quotation #${quotationRef} validated, but the broker e-mail was not sent: ${reason}. Check Settings → Mail History.`,
        time: 12000,
      });
    },
    startLoading() {
      let count = 0;

      // Démarre l'animation du chargement
      this.$vs.loading({
        container: "#loading-radius",
        type: "radius",
      });

      // Intervalle pour mise à jour dynamique du texte
      const interval = setInterval(() => {
        const increment = Math.floor(Math.random() * 5) + 1; // Incrémente entre 1 et 5
        count = Math.min(count + increment, 100); // Bloque à 50 max

        this.loadingText = `Loading Orders: ${count}%`; // Met à jour le texte

        if (count >= 100) {
          clearInterval(interval); // Arrête l'animation à 50%
          this.loadingText = `No orders`; // Met à jour le texte
        }
      }, 80); // Change la vitesse aléatoirement (100ms à 400ms)
    },
    async afterProductionSaved(productions) {
      await this.$store
        .dispatch("dataListDashboard/fetchQuotation")
        .then((response) => {
          this.$store.dispatch("dataListDashboard/fetchQuotationProduct");
          this.$store.dispatch("dataListDashboard/fetchVolumeTotal");

          this.popupActive = false
          this.productionDone = []
          this.$vs.notify({
            title: 'Done!',
            text: 'Production of the week is created/updated',
            color: 'success'
          })
        });
      // Ou recharger uniquement certains éléments sans faire un reload global.
    },
    async LoadProductToBeDone() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45,
      });
      try {

        await this.$store.dispatch("dataListDashboard/fetchQuotationProductPrint");
        await this.$store.dispatch("dataListDashboard/fetchQuotationProductPrintv2");
        await this.$store.dispatch("dataListDashboard/fetchQuotationProductPrintv3");
      } catch (error) {
        console.error("Erreur :", error);
      } finally {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
      }
    },
    removeFromProduction(index) {
      this.productionDone.splice(index, 1);
    },
    addToProductionPending(tr) {
      // 1) Même ligne (commande + produit) déjà en attente
      const sameLine = this.productionDone.find(
        p => p.quotationref === tr.quotationref && p.idproduct === tr.idproduct
      )
      if (sameLine) {
        this.$vs.notify({
          title: "Denied",
          text: "Already in the production queue",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-right",
          time: 8000,
        });
        return
      }

      // 2) Contrainte production : une seule ligne par produit
      const sameProduct = this.productionDone.find(
        p => p.product === tr.product && p.uom === tr.uom
      )
      if (sameProduct) {
        this.$vs.notify({
          title: "Denied",
          text: `Same product already queued for #${sameProduct.quotationref}. Only one line per product is allowed in a production.`,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-right",
          time: 8000,
        });
        return
      }

      // 3) Quantité / m3 nets pour CETTE commande (même formule que l'affichage)
      const stockAvant = parseFloat(tr.stock_avant)
      const stockApres = parseFloat(tr.stock_apres)
      const unitVolume = parseFloat(tr.volume) || 0
      const qty = stockAvant < 0
        ? Math.abs(stockApres - stockAvant)
        : Math.abs(stockApres)
      const m3 = qty * unitVolume

      // Clone pour ne pas muter l'objet source (store / popup).
      // Backend (createproductionfromdashboard) utilise Math.abs(stock_apres)
      // comme quantité encodée → on l'aligne sur qty (cette commande uniquement).
      this.productionDone.push({ ...tr, qty, m3, stock_apres: -qty })
    },
    isFullyPrepared(index) {
      const marker = this.markers[index];
      return Math.abs(((marker.volume - marker.volumetoprepare) / marker.volume) * 100) === 100;
    },
    getPreparationPercentage(index) {
      const marker = this.markers[index];
      return Math.abs(((marker.volume - marker.volumetoprepare) / marker.volume) * 100);
    },
    generatedUrl(type, id) {
      return "/web/" + type.toLowerCase() + "/" + id
    },
    removeDuplicates(str, separator = '/') {
      if (str === null || str === undefined) return '';
      const normalized = String(str);
      const parts = normalized.split(separator);
      const uniqueParts = Array.from(new Set(parts));
      return uniqueParts.join(separator);
    },
    openThePopupTransport(data) {
      this.OpenedPopupTitle = "Transport #" + data.id;
      this.popup_mail_top = "Transporter: " + data.transporter;
      this.popup_mail_top += "<br/>Client: " + this.removeDuplicates(data.client);
      this.popup_mail_top += "<br/>Destination: " + this.removeDuplicates(data.destination);

      this.popup_quotation_dashboard_product = []
      this.quotation_dashboard_product.forEach((elm) => {
        if (elm.idtransport == data.id) {
          let obj =
          {
            category: elm.category,
            categoryro: elm.categoryro,
            currentstock: elm.currentstock,
            date_delivery_desired: elm.date_delivery_desired,
            idproduct: elm.idproduct,
            product: elm.product,
            productro: elm.productro,
            quotationref: elm.quotationref,
            stock_apres: elm.stock_apres,
            stock_avant: elm.stock_avant,
            uom: elm.uom,
            volume: elm.volume,
            volumeorder: elm.volumeorder,
            volumetoprepare: elm.volumetoprepare
          }
          this.popup_quotation_dashboard_product.push(obj)
        }
      });
      this.popupActive = true;
    },
    openThePopup(data) {
      this.OpenedPopupTitle = "Order #" + data.quotationref;
      this.popup_mail_top = data.mail_top;
      this.popupRow = data;

      this.popup_quotation_dashboard_product = []
      this.quotation_dashboard_product.forEach((elm) => {
        if (elm.quotationref == data.quotationref) {
          let obj =
          {
            category: elm.category,
            categoryro: elm.categoryro,
            currentstock: elm.currentstock,
            date_delivery_desired: elm.date_delivery_desired,
            idproduct: elm.idproduct,
            product: elm.product,
            productro: elm.productro,
            quotationref: elm.quotationref,
            stock_apres: elm.stock_apres,
            stock_avant: elm.stock_avant,
            uom: elm.uom,
            volume: elm.volume,
            volumeorder: elm.volumeorder,
            volumetoprepare: elm.volumetoprepare
          }
          this.popup_quotation_dashboard_product.push(obj)
        }
      });
      console.log(this.popup_quotation_dashboard_product);
      this.popupActive = true;
    },
    momentedDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    displayDateddMMyyyy(date) {
      return date ? moment(date).format("DD-MM-YYYY") : null;
    },
    ZoomOnMap(lat, lng) {
      var mapOptions = {
        zoom: 4,
        center: new google.maps.LatLng(lat, lng),
      };
      console.log(this);
      var map = new google.maps.Map(document.getElementById("map"), mapOptions);
    },
    iconColor(value) {
      if (!value.idtransport) return this.whiteIcon;
      else if (!value.transport.people.length > 0) return this.blueIcon;
      else return this.greenIcon;
    },
    labelling(value) {
      return value.quotationref + "";
    },
    totalVolumeReady() {
      this.vartotalVolumeReady = 0;
      let x = 0;
      this.$store.state.dataListDashboard.quotation_dashboard_product.forEach(
        (e) => {
          this.vartotalVolumeReady =
            this.vartotalVolumeReady + e.volumetoprepare;
          this.$vs.loading.close();
        }
      );
    },
    getTitleLeft() {
      let ready = "...";
      let pct = "..."
      if (!this.$store.state.dataListDashboard.quotationvolumetotal
        .volumetotal && !this.vartotalVolumeReady) {
        return "Loading...";
      }
      if (this.vartotalVolumeReady) {
        ready = Math.abs(
          Math.round(
            Math.abs(
              parseFloat(
                this.$store.state.dataListDashboard.quotationvolumetotal
                  .volumetotal
              )
            ) - Math.abs(parseFloat(this.vartotalVolumeReady)),
            0
          )
        );
      }
      if (ready != '...') {
        pct =
          Math.abs(
            Math.round(
              (ready /
                this.$store.state.dataListDashboard.quotationvolumetotal
                  .volumetotal) *
              100
            ),
            0
          ) +
          "%  ready"
      }
      return (
        "Orders in progress ⟶ " +
        ready +
        " m3 / " +
        -Math.round(
          this.$store.state.dataListDashboard.quotationvolumetotal.volumetotal,
          0
        ) +
        " m3 ordered (" + pct + ")"
      );
    },
    getTitleRight() {
      if (this.quotation_dashboard_product.length > 0) {
        let ready = Math.abs(Math.round(parseFloat(this.vartotalVolumeReady), 0));
        return "To be produced ⟶ " + ready + " m3 ";
      }
      else {
        return "To be produced ⟶ calculating...";
      }
    },
    async updateCurrency() {
      // Taux ECB live (même source que la page Comptabilité), repli sur la valeur DB /currency.
      try {
        const r = parseFloat((await axios.get("/currency/ecb")).data.eur_ron);
        if (r && !isNaN(r)) { localStorage.setItem("rate_eur_ron", r.toFixed(4)); return; }
      } catch (e) { /* fall through */ }
      try {
        const r = parseFloat((await axios.get("/currency")).data.eur_ron);
        if (r && !isNaN(r)) localStorage.setItem("rate_eur_ron", r.toFixed(4));
      } catch (e) { /* keep whatever was already in localStorage */ }
    },
    ViewStock(value) {
      this.quotationRefClickedPrompt2 = value;
      this.activePrompt2 = true;
    },
    getDistanceColorQuotation(distance) {
      if (distance > 1500) return "danger";
      else if (distance > 750 && distance < 1500) return "warning";
      else if (distance <= 750) return "success";
    },
    getDistancePctQuotation(distance) {
      var maxDistance = 1500;
      return (distance / maxDistance) * 100;
    },
    getDistanceColorPurchaseOrder(distance) {
      if (distance > 500) return "danger";
      else if (distance > 250 && distance < 500) return "warning";
      else if (distance <= 250) return "success";
    },
    getDistancePctPurchaseOrder(distance) {
      var maxDistance = 500;
      return (distance / maxDistance) * 100;
    },
    async loadSale() {
      axios.get("/dashboard/10sale/data").then((response) => {
        this.saleList = response.data;
      });
    },
    async loadcurrentlyworking() {
      this.currentlyworking = []
      this.pendingLeaveCount = 0
      axios.get("/employees/getattendancedashboard").then((response) => {
        // Données proxifiées depuis XYLO-ATTENDANCE : { pendingLeaveCount, livePresences }
        this.currentlyworking = (response.data && response.data.livePresences) || [];
        this.pendingLeaveCount = (response.data && response.data.pendingLeaveCount) || 0;
      }).catch(() => {
        this.currentlyworking = [];
        this.pendingLeaveCount = 0;
      });
    },
    // Heure du check-in (HH:mm) — le "depuis quand".
    checkInTime(checkInAt) {
      return checkInAt ? moment(checkInAt).format("HH:mm") : "";
    },
    // Durée écoulée depuis le check-in, formatée "Xh YYmin" (reproduit l'ancienne colonne timing).
    presenceDuration(checkInAt) {
      if (!checkInAt) return "";
      const mins = moment().diff(moment(checkInAt), "minutes");
      if (mins < 0) return "";
      const h = Math.floor(mins / 60);
      const m = mins % 60;
      return h > 0 ? `${h}h ${String(m).padStart(2, "0")}min` : `${m}min`;
    },
    openAttendance() {
      this.$router.push("/attendance-sso");
    },
    // Price check (test phase) — admins and moderators. A failure is shown in the card (in one line),
    // never as a popup: it must not get in the way of the dashboard.
    loadPriceCheck() {
      this.priceCheckError = null;
      axios.get("/pricecheck/summary").then((r) => {
        if (r.data && typeof r.data === "object" && Array.isArray(r.data.quotes)) {
          this.priceCheck = r.data;
        } else {
          this.priceCheck = null;
          this.priceCheckError = "unexpected answer from the server";
        }
      }).catch((err) => {
        this.priceCheck = null;
        const d = err && err.response && err.response.data;
        this.priceCheckError = (d && (d.detail || d.message)) || (err && err.message) || "network error";
      });
    },
    pcQuoteHref(qt) {
      return this.$router.resolve({ path: "/quotation/" + qt.idoperation }).href;
    },
    // Close the popup BEFORE leaving: Vuesax moves it under <body>, so it would stay on top of
    // the quote page with nothing left to close it.
    openPriceCheckQuote(qt) {
      this.priceCheckOpen = false;
      this.$nextTick(() => {
        this.$router.push({ path: "/quotation/" + qt.idoperation });
      });
    },
    pcPct(x) {
      const pct = Number(x);
      if (!Number.isFinite(pct)) return "";
      return (pct > 0 ? "+" : "") + pct.toFixed(1) + " %";
    },
    // Niveau du devis : médiane des écarts de ses lignes comparables ; « n/a » quand aucune.
    pcQuoteLevel(qt) {
      if (qt.quote_pct == null || !(Number(qt.quote_applicable) > 0)) return "n/a";
      return this.pcPct(qt.quote_pct) + (Number(qt.quote_applicable) < Number(qt.quote_lines) ? "*" : "");
    },
    pcWorstDelta(w) {
      if (!w) return "";
      if (w.pct != null) return this.pcPct(w.pct);
      if (w.status === "no_price") return "no catalogue price";
      if (w.status === "unit_mismatch") return "unit mismatch";
      if (w.status === "no_conversion") return "no conversion";
      return w.status || "";
    },
    priceCheckQuoteTitle(qt) {
      const parts = [];
      parts.push(`${qt.errors} probable error${qt.errors === 1 ? "" : "s"}, ${qt.diffs} difference${qt.diffs === 1 ? "" : "s"}, ${qt.infos} not comparable`);
      if (qt.quote_pct != null) parts.push(`quote level ${this.pcPct(qt.quote_pct)} on ${qt.quote_applicable} comparable line${Number(qt.quote_applicable) === 1 ? "" : "s"} of ${qt.quote_lines}`);
      if (qt.worst && qt.worst.flags) parts.push("flags: " + qt.worst.flags);
      if (qt.worst && qt.worst.note) parts.push(qt.worst.note);
      return parts.join(" · ");
    },
    pcDate(d) {
      return d ? moment(d).format("DD/MM/YY") : "";
    },
    // Nothing explains a probable error: red. Nothing explains a difference: grey.
    pcWhyClass(line) {
      const first = line && line.why && line.why.reasons[0];
      if (!first || first.kind !== "none") return "";
      return line.severity === "error" ? "text-danger" : "pc-why-none";
    },
    pcMoney(x) {
      const n = Number(x);
      return Number.isFinite(n) ? n.toFixed(2) + " €" : "";
    },
    async GenerateDocumentInternalLoadingv3() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: `#button-sorted-by-category`,
        scale: 0.45,
      });
      await this.$store.dispatch("dataListDashboard/fetchQuotationProductPrintv3");
      const doc = new jsPDF({
      });
      // SET FONT FROM ASSET ASCII
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      doc.setFontSize(10);
      var img_logo =
        "data:image/png;base64,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";
      // TOP MAIL
      doc.addImage(img_logo, "JPEG", 10, 5, 30, 11);
      doc.setFontSize(14);
      doc.text(70, 20, "FISA DE PRODUCTIE " + moment().format("DD MMM YYYY").toUpperCase());
      doc.setTextColor(0, 102, 204);
      doc.text(
        20,
        32,
        "Total de produs: " +
        Math.abs(Math.round(parseFloat(this.vartotalVolumeReady), 0)) +
        " m3"
      );
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(10);
      doc.text(20, 37, "Lista grupată pe produse cu data livrării de la prima comandă.");
      doc.text(20, 41, "Sortare după categorie si volum descrescător.");
      doc.setFontSize(9);
      let quantitystr = "Cantitate";
      let volumestr = "Volum (m3)";
      var col = [
        { header: "Categorie", dataKey: "categoryro" },
        { header: "Produs", dataKey: "productro" },
        { header: "Data de livrare", dataKey: "date_delivery_desired" },
        { header: quantitystr, dataKey: "quantityorder" },
        { header: volumestr, dataKey: "volumetoprepare" },
      ];
      doc.autoTable({
        margin: {
          top: 45,
        },
        theme: "grid",
        styles: {
          fontSize: 6,
          stock_apres: { halign: "right" },
          volumetoprepare: { halign: "right" },
        },
        columnStyles: {
          stock_apres: { halign: "right" },
          volumetoprepare: { halign: "right" },
        },
        body: this.$store.state.dataListDashboard
          .quotation_dashboard_product_print_v3,
        columns: col,
        willDrawCell: function (data) {
          var rows = data.table.body;
          doc.setFont("Amiri");
        },
      });
      doc.setFontSize(8);
      doc.save(moment().format("YYYYMMDD") + "_" + "InternalProduction.pdf");
      this.$vs.loading.close(`#button-sorted-by-category > .con-vs-loading`);
    },
    async GenerateDocumentInternalLoadingv2() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: `#button-grouped-by-product`,
        scale: 0.45,
      });
      await this.$store.dispatch("dataListDashboard/fetchQuotationProductPrintv2");
      const doc = new jsPDF({
        /* filters: ["ASCIIHexEncode"],
        orientation: "portrait",*/
      });
      // SET FONT FROM ASSET ASCII
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      doc.setFontSize(10);
      var img_logo =
        "data:image/png;base64,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";
      // TOP MAIL
      doc.addImage(img_logo, "JPEG", 10, 5, 30, 11);
      doc.setFontSize(14);
      doc.text(70, 20, "FISA DE PRODUCTIE " + moment().format("DD MMM YYYY").toUpperCase());
      doc.setTextColor(0, 102, 204);
      doc.text(
        20,
        32,
        "Total de produs: " +
        Math.abs(Math.round(parseFloat(this.vartotalVolumeReady), 0)) +
        " m3"
      );
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(10);
      doc.text(20, 37, "Lista grupată pe produse cu data livrării de la prima comandă.");
      doc.text(20, 41, "Sortare după data de livrare.");
      doc.setFontSize(9);
      let quantitystr = "Cantitate";
      let volumestr = "Volum (m3)";
      var col = [
        { header: "Categorie", dataKey: "categoryro" },
        { header: "Produs", dataKey: "productro" },
        { header: "Data de livrare", dataKey: "date_delivery_desired" },
        { header: quantitystr, dataKey: "quantityorder" },
        { header: volumestr, dataKey: "volumetoprepare" },
      ];
      doc.autoTable({
        margin: {
          top: 45,
        },
        theme: "grid",
        styles: {
          fontSize: 6,
          stock_apres: { halign: "right" },
          volumetoprepare: { halign: "right" },
        },
        columnStyles: {
          stock_apres: { halign: "right" },
          volumetoprepare: { halign: "right" },
        },
        body: this.$store.state.dataListDashboard
          .quotation_dashboard_product_print_v2,
        columns: col,
        willDrawCell: function (data) {
          var rows = data.table.body;
          doc.setFont("Amiri");
        },
      });
      doc.setFontSize(8);
      doc.save(moment().format("YYYYMMDD") + "_" + "InternalProduction.pdf");
      this.$vs.loading.close(`#button-grouped-by-product > .con-vs-loading`);
    },
    async GenerateDocumentInternalLoading() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: `#button-sorted-by-quotation`,
        scale: 0.45,
      });
      await this.$store.dispatch("dataListDashboard/fetchQuotationProductPrint");
      const doc = new jsPDF({
        /* filters: ["ASCIIHexEncode"],
        orientation: "portrait",*/
      });
      // SET FONT FROM ASSET ASCII
      doc.addFileToVFS("Amiri-Regular.ttf", AmiriRegular);
      doc.addFont("Amiri-Regular.ttf", "Amiri", "normal");
      doc.setFont("Amiri");
      doc.setFontSize(10);
      var img_logo =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABMCAYAAAAoefhQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAABXgSURBVHhe7Z0LfFXFnceTe/PgIdLVUKtoAVtFW0GUlg80QEKChFBQ64Ira1UqVbdgpdbubm0FX1h5VAtWxWqR2q3uamtRaMuSJoZcELpattpFi8pCAlSURLQEIQ+S7Pd37pl4bnJfSW4298b5fT6/z8yZc+553fnP/zFzZtLz8vL6pqenn5OWlnYCNGj0+/2vlpWVHXO3OwzO6+O8Z5D9dLCkFVUtLS17Kyoq3M2eR0FBQWZzc/NZZE8OlrRix6ZNm9538yGYNWtWWnV19UlkB8F0eCgjI6OmtLS0Wfstegd8UILxTVgKAy5Lm5qaZpN2Gj6fTxXnYShJMOd9EuEYTZo0mDBhQjrCoXt6Epr7FH8C2wpMKxCOU0mmwWKYz3NdyjsbrH0WvQe+7OzsGtIf8Qe/Gixy0B/+S35+fqcqM61rOue7iewUqNZV+BCuRnBKkkl7cJ+fILkVjnAKgjhE+Z1oj13udghyc3P1fOfATDZPhMdhE9vjtd+i98BXUlLSgim0g4qrCv1OsNjB2XDppEmTzi4sLDSVPCY4PpPW9etk58EMpzAtTWbHM3BlTk6OBCUpgGnVB7Po+2SnQ79TmJZWC5fxTtYFN9uD3+i5sjnmPdLTEAxpkzeh1SC9DE6lqKysFPcPHTq0hc1cmAUlFKcrjwmypaqqqp58VKBxZLLp93dBr+/xJyrTfFrkd15//XW3qGeBaZXBPc0kexvs6xSiBeAzlC/nXj8IFrXHyJEjWxobGz9JdgjH/ol0N/wM5DVVSVAseglUoVvBn/0EiVp6VRRBgvJVyi8LbsaEKo3MlXOdrSCqZa6Ul5dXuttJATTmhSS3wIFOAeA+98B7uNd33aKwWL9+PYe1vMZ7eZf0LNJRnK+RdKt7iEUvQYiA8CcfIlkKy6GJxsjG/gGm0zg0RERTi/19qCyLyF4EjblyGC6R3xHcTA7wHGdQmXWvo6B5pmrKFjQ0NLzlbkcFGuZvJBvhT+Fj/PbprKwsvT+LXoSwFZ4KlE+yBg51Cmhc4SYE4Bs42G8Eiz4Ch8tZvQr+GPZTGWiEa6g436dFViAgKVBUVJRZX1+/mOx3oGkgVNnv5V4f4F47Hdq26H0I0SAeBBCGH5I2BDcdQRpHBZqXl5enqE8rXK0yFn4bGlteeA0uTSbhEBCOS0iug+bZFX3aAJ+wwmHRFmEFBPOhGWFQv4DMB2kCoQ+cS/mVCIX3d2fChVB+h9FIiobdXFtbK+c1KSBBRrgVhpVT7hVy+RILMa28ETwLCwfGV2iHysrKuqFDh8oeVy/7MCihkNP+JVrbrWPGjNmbk5PTh8p1D2WzoBEO2eF3Uv781q1bjbPf4xg2bNgQEt3rBGju9QD3qejay/v373eLLCw+QiQTy2AXwiCn3Vt7BlKpbq+urj6b9Aq2rwwWO5BJ9izlT2OuGPMsKcBzaLRASMclZQ81Nzer19zCIiwiahBB/SO0vPvIKho1Fep4VTB1iI1GEGaQKrRr8DKVbsGgQYMOJEt/h8zBIUOGzORe72bTBBDU8y1BXopp9YHVHhaRYFrTqMB2lym1jOz1MNspbAMEQ4I0s6Ki4qVgSc+jqKjIh1M+juxqONwpDOJFnmcOWi7sUBILC4NYJpaDfv361VGhHiCrQVThRqt+wP7lPp9PvcpJg7q6Oo0E+Gf4WacgCMdHssJhEQ/iEpANGzaol303vJdNaQovZK6shU/htJuIV48D0yqL+5XfUQSNKVkH70PbJc9oSYukRlwC4kIjWDXK1wxANJCZlo32UGdhMkEDEG+GCk8LGkv2M57hUczApAogWCQv4hKQ4uLitObmZo3ulbmikateqHWezv6rDx48qDBwskAdgt4gxB/hSoQjqTouLZIbcQnIsWPH1EOugX1fguF+cyIt8y1okS+628mAkAgd5tbTJO2GyVhYRENMAcGWl+k0H86FxozSkIz1sDWWSwX8JFrk0UmTJp3Lb9zSpMKhTZs2aUyZhUXciCogGp5BUggXOAVBqJKVoTFUdgc8okIBITkLIbmVfW3NMAuLlEQsDaLxVf8KT3O2gtBXdIuw5fcgDM+TVx+DQSZCcgn8qoa/u2UWFimLiAJCBdekC/ocdSI0x2mGD2mOV7QRCAQa0BbqQHwWKtwr6PuRhZQXjx49Oq6OSAuLZEVYAdHwDCr4tWQ1CNEccxQ+Cn/jteXRFm+TLIf/A035AHh3//79vV8WWlikHCJpEHWuqZPNOOXqPd8MH0E4NC6rFWwr2Q7vRai8EzIM9/l830UTneJuW1ikHEIEhMqcjva4gKw+R/X6HXvQFLf4/f4qdzsECMlx9q9FIFawaSZ3UIfiTIRmPuf1TkpnYZEyCBEQKvMp8Ltkx0DjP2js0m3l5eWvlZWVRQyTsl9CspKspssx/oj6T+ZxTvVqW1ikHNoKyPVUcg1hN+XSBo/D3zhbMcBvFeHSp7p/dgqC0OyEi/Ly8jS1p4VFSsERBDnlcDoV/FtseueI+h1C80B2dnZrX0c0SMOA7ZxHgxq9n7AOp2wJQvIpzWlrYZEqkGDIlLqQiq0Piv7OKQ1iB1R/x76NGzW7TXzg+CbMLYV9NcOJGRQoQZyKkCyoqalRGNjCIiWgcK76O+ZRefXduUK5YjW8G+dbQtIZaDpThYSfg+acwuVcrxCn3d3sPnAdCae5tmj8IguLuKGWXVNs3gnlmCuCJWqKn4hz08YDfi9/RGO4zDkvoNJqJvT/r28x1MnZem24AVpYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWHQHet2kCpMnT+7T1NQ0rKWlRStf5aSnp2eS15y8f4W7MjIy3i4tLU2ahX0skhshApKfn/8FKpMmYDAIUKGWlJWVJe3afQiE7/jx4zlkR3Dv+thkMkKhj7T0ya+ZXVFfQkooNLm2lqNeyzFay3kP+VrvJBQWFl6EfFFIpTkJ5nt4HgyZwjOZkJeXdyLCcTnZn8N13OsNUAv6aw1CfQevj79ELZyjmVZOglof/W6EQ0tT6+vH8TQMbSfktrBwECIgqQSEYwjCcBdZrVuiWVjM6lHxQitjfR0+AucXFBQMVKGFhRcpJyDjxo3TzCtjEI5fsPkNqA++DDQ9kdY8l7+h5eB+RfoU1AyQmkf4XWg+3hJkYn4OLm5ubl7GebXgjoVFK1JKQGbNmpWelZWlj59kUmlJZ+9yC9UIxC/hdXBMY2Pj2IqKiln4F1fCS/GlRiFUBRynqVRfgN7v7GWOaXm5+xCSTzklFhYgxL8YNmyY7PerglsO/uLz+Z7bvXt3Uiw4M2jQoHOp5AoieKclOo5ABCi/ByFYWV5evr2qqqp23759IY43z9BcWVlZDV/iOSv4zTv8Rs+r7/DNubSOof/MM8/8w549e8z8XhYfY6SEBsGs0qR2CiDcxKa0gKnQjdIaCPE17HumrKxMcwfHBEJUxe8e5jdfY/NVaIRJzvoc9l0+ZcoU67hbhIZ5qYRTqBzeKUx+Tat8TWlpaVzT/nQXJk6cSF1OvxKuYtPM0ljP9lN+v/+mrtwfzvnZ+B//Tlamm3kfmmf4KkwzCU9CMHny5MympqZPcK1j8MPNmzdHDC0XFhZmcUzfAQMG1K5bty7coqkRgYk4gAajmf/taElJScRrjB07NrNPnz79eYduyUfg2o38vo4Gp9P9RdxHX+6j6YUXXuiy9cH/n8X/fDJ10/nvuec63uXBQCAQU8tTp2UlaenADikDrlUP6lJCg/Tr108Lckp7GOFQpQnAJX379u2S8PKi/5dEk1bsdgqCOI8XlNAJvLjOWM65iue4gT87asSNY/M5dmVtba2WkYsbVIYhJCuo4Dc2NDQopB0WeXl56dnZ2blkH+I67cg9Psg9LKaST1NFD/4qfij8TjKP+7giWNI5cO1MWMz9/ID7UrTxp3A1+UcRvh+y7ys8c9RppDh2OPyxnqsj5KfX8Y4GpISA1NXVaQkG9V8YVPPSHuFP3LV+vRa66jw0jxcV9vdkNZeXaZHUrM4tKipSy5MQ8NK1FPXfw/HkY63lqMjabI67nUowAu0TLI0CWtn+HP89snPgZPLq94kEXl/6OaT/CP8BXtaGs6EWQNXUTcu5h8GQbGygkXXyL5DVjDbf4768Uca4MGHCBD2PfMMlcDXnu5F0ClQdGAnzoIIqEpoVCIk6iiNB4fyvwLbPOBPq+SXEbfeJWm6wb9ILCOaGnz9bf3prQIHtkhNOOGEdKrZD5kckaKSABI7sW8ESpwadgoq92N3sMjifm+sQRsDbjx8/7p1IvB1osbXKsPp01Gka8z/l/Tl08Xvu7Xw40uUFcCrlS6GG6CiUvpjjvZMKRgTHqT/pajhU5Fw3UNnj9uc08ybPMhg+zKZWGJCFsITzaP3LgWhV+aKaqVPTOr3P9a6BqxCSsP1YmIrbONcIjjfP55BdqlPCH6Bs+Lb753Otg0kvIKjpU7nh89xNB2yvRnMkdCI4HHcNO1HvuoFq9EUKLQc3ewRqAKQ+ZiMEYbWOp8X+J9jRzlKhlgr2Fs9vuBNqTQstr6dVjRX4uIxrxLXWC+eSUGt+55fhh/zuYiqoVkiOCzU1NTKnpdV0Dq09Mx9TZzH3tAOfsHn79u3N5LVW/wqO08KyMpHlO19K2g74p/X4QVXus7WSe9rvHqJ+sd1t93Ot97hWS9ILCA+ul+ttvQ7wcP/t5iOCFiUdjsI0mEp6epwmwu/c1GA4f1iP9bDz7PoTVUlu5plldrUDDYgE5zaowZkyFRMyEJMKwuVbysnK15OdLyGMBzJ9ZJo+ATX5oIYrTVWQgnxMcE2jgXSO+2Hpxo0b2zWGVGKtJlBKVs8sP6mQa3TYX4qFVBAQOZ7GORdexveIGr1AGAbwu5VQgrSBdCfpbMy1qM9LJdRCQN5FgCSYPdm7rsCBxov14xlWoS1COjER/GzKbyV7EdQM/HLIEmJ2ulAEam8w69jyUcH9SNspsKA16dUZez/3p1D8tZiJ8c7ur76o86Eiic9LUFUYDmgGRTJ/SzbANf5KvUj4Ov1JLyBALYr3wd/mpcSqBHLiFIUy5pFao5tlrgU3w4P9an29s9Jn8eJ7TIMAtZKq9GvheVSAmzC1nMZixowZ+u8K2a/ludWvIx9K2iZh4NzZJOpMFTR8JyIQjoHcwzVk5SuW0djI9NnNOTQ/s7RfWBMoDBTMEN7kfN7GKiwOHz78n36/f1pFRcWtaBUNM0ookl5AeMESDm+PvxzHWJCD2DYCdTICEEsbqLXynl8BgrhMg+4Cf3o1962FUg/wLq6GhePHj/fhQOqbF4W+pVUeoULKFIrY2nYGXEuzjCuCKGf4JacwAtg/lmQiaQ2/e4rWvZF7kn3/DNQYuOsRomjRJgf81kTfjpCP6WfKJykrK+u2kR6poEFUYb0vymtuhQV/0l9ItDKWF/v4w/QtSETwO2kc7/nVgscjkN0KBOQN7k0OqSrP7ZmZmQp3ai0XrWG/ESd2BYLU2aExMiNHY5YafhEtNZ30Qa65hn0Suvt5D3qnYcHx+v5GQ5TO4B0/xrFvqhwh0Sz/W8jK/DuV5/gmQhI1osU1zf8mzR2zcVKUUyY199CXNOEBlVQQEEVRvH++tEPU+87IyNCCoxoGrz9VJtM2qEiIWrKIQFVL63jtfAlHXMNXuhNbtmxRyyqbXh1l51KJpFFkWu2k/A6cWH0I1lnIb1DESX6D+BLnlFmnqJgie3exvQpfwDsKOgTsH00yDep/eo/7m4YgfFlkW4NKZfrIX7iUfWGDDR4o1K4GUcfFNG8xOzUCQvcoAU342vypYGIpkuO1Rc/PAm4+LFyVq97Qq/lD1Ol1bU1NTZn2RQMtnOLfsrsNahG2A26+p6GQqTru/gsqJCfhXcXzyZntCuQr3AcVDBCXcx1FxdRPMIfnf4iGRUtZRMMNUJoog/tZBH/iJeWKSikELUd9Bi299x23hbT8a1Dr1ahzMBqkMdRXpb4a+Z0JRypoEL0sLehjkNPQ0CDTIipo8erhH3HeSDbt3LFjR1T7nD9Nfk7b4SXbMWdq3XyPgmdQY/EmVO9yJRXvPzBn/o3yLtnfnGcnvM3DhVxjGdr0SXa/on6E4JHhwXuTn6KORa2E/Av4HNTXnV7quxyFfVXfruAa50ycKNcmLGRiacydGoA7OP8UNFG/GTPULfIRCgoKMinXwFU5/zpWDWDCPw1PegGh9TpIolbTQK3GXF5coqNL5/PHeQVPAvXbDRs2JNTx7Qpk0wMNJl0Ml7CdCOFVRLCehqSVcrDRwi0Symigguo/UOutd/Q4gnA9/9e8cHSP0yJGn+e4WQh3WH+Ba8q80rAfaUtpnTUS2iNHjmhc2IVQfVv5aPtvUS4zWqbYWjTdL2Pdb2eQChpELadG23or6jio1aoSAncc01VcZ7BbJOxlWw5mUoFK0NLY2PhzKrLpn+gx8M6kBjRmaT/v6lkJlrMjDNivfT+DWtHsWip4xA/TeMYaEpl7WjdTmv07XOsxUq24rMDBangPVNheA0AXoem6RdOnioAoxOj1IRQ1UZ+AWpQuRS5yc3MzaM0u4RoatGZ8G7Visr0TNsyfCvEKiUaVql8glimwnePkQ8k0aYcXX3wxbPiT37wFH4bP8kyqiGFBa6voku7nQRj2GrHAu5e/Iai1l1n2RnBPePAudU0FTxbqN+SjfrmJkLzDcSvITiL9NqnC2BKCD9l2FpjlHNL4WtdfQ086BJz7vZxHGuhXnCfi/xFSuVCZSfk9CEKgRBMzqAXyvlgNDVnAy9wV3OwYiouLfUePHtU0QVLn6rEXpKkCVOg5gUAgaljYovcjJTSIbEtaRI261EQN3n4JOYf30ZopzNghIHSZCMfFCIdUuREOQWFhdbyZwWwWH2PE1CB+v/9rDQ0NXdIgmZmZcjC7NEaI1l7fhXya+5NZoPi6EW4ND9GMJQ9S2X9N+j7qPOyAPcwpmRcyo07nWH2vILNKdqx5D1K1y1C/Szdv3pzwiIhF6iGWgGjw3uOUdbaX1gGVsRot0KVlpQ0KCgoGY/5Ik0yA3iEogrTMk9zvn3VN8odJm9hWj+xJpKexrS/75pJ6HXJB9u2a+vr6W7Zt2xbWxrf4+CGWgCQK2xGQeIdLxwTmkb4P0fcK0iRte09VudVjLsdN0RBpE3VMyXeRKaVZF0OeG+gLRXVoachGrE4xi48RUsIHCYPX8RE0UG8JAq1ojdd801gfaQcNnpsONfxavsooqN5er3BIeDRu6EYEZFlOTo4VDosQpKQG8QIHXZ+IauCeBELjtKIOQ3FxGCokqo6rByoqKrw99RYWrQgREEwXfcivXs9EYy8ComhRtwC/pD9+iT6ykV+iiJa+KZDzbcYHaaCchECRKX08JV9lS1ZW1q6SkhLrb1hERIiA5Obm+kHCR0RyziZse294tlswdepUf0NDg777MLO790E4ZEY2ISBHYS37DlH2t0AgkDRDSCySFWlp/wcLRrzpVQ26xQAAAABJRU5ErkJggg==";
      // TOP MAIL
      doc.addImage(img_logo, "JPEG", 10, 5, 30, 11);
      doc.setFontSize(14);
      doc.text(70, 20, "FISA DE PRODUCTIE " + moment().format("DD MMM YYYY").toUpperCase());
      doc.setTextColor(0, 102, 204);
      doc.text(
        20,
        32,
        "Total de produs: " +
        Math.abs(Math.round(parseFloat(this.vartotalVolumeReady), 0)) +
        " m3"
      );
      doc.setTextColor(0, 0, 0);
      doc.setFontSize(10);
      doc.text(20, 37, "Listă sortată după comandă, negrupată după produs.");
      doc.setFontSize(9);
      let quantitystr = "Quantity";
      let volumestr = "Volume (m3)";
      var col = [

        { header: "Quotation", dataKey: "quotationref" },
        { header: "Client", dataKey: "client" },
        { header: "Category", dataKey: "categoryro" },
        { header: "Product", dataKey: "productro" },
        { header: "Date Delivery", dataKey: "date_delivery_desired" },
        { header: "Date Transport", dataKey: "transportDate" },
        { header: quantitystr, dataKey: "stock_apres" },
        { header: volumestr, dataKey: "volumetoprepare" },
      ];
      doc.autoTable({
        margin: {
          top: 45,
        },
        theme: "grid",
        styles: {
          fontSize: 6,
          stock_apres: { halign: "right" },
          volumetoprepare: { halign: "right" },
        },
        columnStyles: {
          stock_apres: { halign: "right" },
          volumetoprepare: { halign: "right" },
        },
        body: this.$store.state.dataListDashboard
          .quotation_dashboard_product_print,
        columns: col,
        willDrawCell: function (data) {
          var rows = data.table.body;
          doc.setFont("Amiri");
        },
      });
      doc.setFontSize(8);
      doc.save(moment().format("YYYYMMDD") + "_" + "InternalProduction.pdf");
      this.$vs.loading.close(`#button-sorted-by-quotation > .con-vs-loading`);
    },
  },
  // Any navigation away (link, back button) closes the price-check popup first: it lives under
  // <body> and would otherwise stay over the next page.
  beforeRouteLeave(to, from, next) {
    if (!this.priceCheckOpen) return next();
    this.priceCheckOpen = false;
    this.$nextTick(() => next());
  },
  created() {
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin")) {
      this.isAdmin = true
    }
    if (localStorage.getItem("login-roles").toLowerCase().includes("moderator")) {
      this.isModerator = true
    }
    if (localStorage.getItem("login-roles").toLowerCase().includes("broker")) {
      this.$vs.notify({
        title: "Broker access",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/broker/dashboard" })
    }
    if (localStorage.getItem("login-roles").toLowerCase().includes("accountant")) {
      this.$vs.notify({
        title: "Denied",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: landingPathFor() })
    }

    if (localStorage.getItem("login-roles").toLowerCase().includes("attendance")) {
      this.$vs.notify({
        title: "Denied",
        text: "Attendance Only",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: '/employees/attendance' })
    }

    if (localStorage.getItem("login-roles").toLowerCase().includes("invoice")) {
      this.$vs.notify({
        title: "Denied",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/invoice/invoice-list" });
    }


    if (localStorage.getItem("login-roles").toLowerCase().includes("wood finder")) {
      this.$vs.notify({
        title: "Denied",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/woodfinder" });
    }
    try {
      // this.$vs.loading();
      if (!moduleDataListDashboard.isRegistered) {
        this.$store.registerModule(
          "dataListDashboard",
          moduleDataListDashboard
        );
        moduleDataListDashboard.isRegistered = true;
      }

      this.isLoadingEFactura = true
      this.$store
        .dispatch("dataListDashboard/fetchQuotation")
        .then((response) => {
          this.$store.dispatch("dataListDashboard/fetchQuotationProduct");
          this.$store.dispatch("dataListDashboard/fetchVolumeTotal");
          this.$store.dispatch("dataListDashboard/FetchSumalDashboard");

          this.$store.dispatch(
            "dataListDashboard/fetchDashboardTransportwaitingfordepartureDash"
          );

        })
        .then((response) => {

          setTimeout(() => {
            this.loadcurrentlyworking();
            this.updateCurrency();
          }, 30);
          if (this.isAdmin || this.isModerator) {
            // Compteurs casa de marcat : un simple COUNT local, donc pas de
            // raison de le faire attendre les 2 s de temporisation du SPV.
            this.$store.dispatch('dataListDashboard/refreshFiscalCounts')
              .catch(error => {
                console.error("Erreur compteurs casa de marcat : ", error);
              });
          }
          if (this.canPriceCheck) {
            this.loadPriceCheck();
          }
          if (this.isAdmin) {
            setTimeout(() => {
              this.$store.dispatch('dataListDashboard/refreshMenu').then(() => {
                this.isLoadingEFactura = false
              }).catch(error => {
                console.error("Erreur lors du rafraîchissement des données : ", error);
              });
            }, 2000);
          }
        })
        .then((response) => {
        });
    } catch (error) {
      alert("LOADING DATA ERROR / CHECK YOUR LOG");
      console.log(error);
    }
  },
  mounted() {
    // Defer to nextTick: refs/IDs inside v-if blocks aren't in the DOM yet
    // when this hook fires synchronously, so $vs.loading() can throw
    // "insertBefore on null".
    this.$nextTick(() => {
      if (document.querySelector("#loading-radius2")) {
        this.$vs.loading({ container: "#loading-radius2", type: "radius" });
      }
      if (document.querySelector("#loading-radius3")) {
        this.$vs.loading({ container: "#loading-radius3", type: "radius" });
      }
      if (document.querySelector("#loading-radius")) {
        this.startLoading();
      }
    });

    // Check 2FA status; if not enabled, show the reminder popup once.
    this.check2faStatus();
  },
};
</script>

<style lang="scss">
/* Price check popup: seven columns, the last one is prose — give it room. */
.price-check-popup .vs-popup {
  width: 96vw;
  max-width: 1680px;
}
.price-check-popup .pc-why {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 280px;
  max-width: 520px;
  white-space: normal;
  line-height: 1.4;
}
.price-check-popup .pc-why-more,
.price-check-popup .pc-why-none {
  color: #999;
}
/* ✓ / ✗ badge in front of the explanation: pops in, wiggles on hover. */
.price-check-popup .pc-why-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.price-check-popup .pc-badge {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  color: #fff;
  animation: pc-pop 0.4s ease-out;
  transition: transform 0.2s;
}
.price-check-popup .pc-badge:hover {
  animation: pc-wiggle 0.4s ease-in-out;
}
.price-check-popup .pc-badge-ok {
  background: #28c76f;
  box-shadow: 0 2px 6px rgba(40, 199, 111, 0.45);
}
.price-check-popup .pc-badge-ko {
  background: #ea5455;
  box-shadow: 0 2px 6px rgba(234, 84, 85, 0.45);
}
@keyframes pc-pop {
  0% { transform: scale(0) rotate(-90deg); }
  70% { transform: scale(1.25) rotate(8deg); }
  100% { transform: scale(1) rotate(0); }
}
@keyframes pc-wiggle {
  0%, 100% { transform: rotate(0); }
  25% { transform: rotate(-12deg); }
  75% { transform: rotate(12deg); }
}
/* The "Approve broker quotation" popup is opened from within the fullscreen
   products popup (z-index 52000), so it must sit above it. */
.pending-approval-popup {
  z-index: 999999 !important;
}
.fill-row-loading {
  display: flex;
  z-index: 1;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;

  .loading-example {
    width: 120px;
    float: left;
    z-index: 1;
    height: 50px;
    border-radius: 10px;
    margin: 8px;
    transition: all 0.3s ease;
    cursor: pointer;

    h4 {
      z-index: 1;
      position: relative;
      text-align: center;
      padding: 10px;
    }

  }
}

.gm-style-iw {
  padding: 10px !important;
  /* Uniformise le padding interne */
  padding-top: 0px !important;
  /* Supprime le padding en haut */
  margin-top: 0px;
  /* Supprime la marge en haut */
  opacity: 0.95;
  /* Légère transparence pour lisibilité */
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.2);
}

.gm-style-iw>div {
  padding-top: -18px !important;
  /* Supprime tout padding ajouté dans le div interne */
  margin-top: -18px !important;
  /* Supprime toute marge interne */
}

button.gm-ui-hover-effect {
  visibility: hidden;
}

#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
.ag-grid-cell-chips {
  top: 12px;
  transform: translateY(-50%);
  line-height: 1;
}

/* Pending admin validation: no row background — only the status chip (green/red)
   turns gray via :color binding in the template, plus a small "Waiting for
   validation" chip / "PENDING TO APPROVE" action. */
</style>
